import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  HostBinding,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { CameraService } from '../../../core/services/camera.service';
import {
  catchError,
  debounceTime,
  exhaustMap,
  expand,
  filter,
  forkJoin,
  interval,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  timer,
} from 'rxjs';
import { IncidentCategoryService } from '../../../core/services/incident-category.service';
import { WindowService } from '../../../core/services/window.service';
import { DataService } from '../../../core/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModalComponent } from '../response-modal/response-modal.component';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { FloorVisualizerComponent } from '../floor-visualizer/floor-visualizer.component';
import { FloorService } from '../../../core/services/floor.service';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { CoresService } from '../../../core/services/cores.service';
import * as Cesium from 'cesium';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceService } from '../../../core/services/device.service';
import { IncidentVisualizerComponent } from '../incident-visualizer/incident-visualizer.component';
import { SafezoneCreatorComponent } from '../safezone-creator/safezone-creator.component';
import _ from 'lodash';
import moment from 'moment';
import { IllumLiveService } from '../../../core/services/illum-live.service';// adjust path as needed
import { TimelineService } from '../../../core/services/timeline.service';

import { ArcAngelLiveModeService } from '../../../core/services/arc-angel-live-mode.service';
import * as turf from '@turf/turf';
import { MultipleMessageComponent } from '../organization/multiple-message/multiple-message.component';
import { UserSearchUiComponent } from '../user-search-ui/user-search-ui.component';
import { ThreeIntegrationService } from '../../../core/services/three-js-building.service';
import { BlenderCameraComponent } from '../blender-camera/blender-camera.component';
import { ViewerAlertRecord, ViewerLiveUserData } from '../../../core/interfaces/building-3d-viewer-interface.interface';
import { VehicleMonitorService, VehicleMonitorSnapshot, VehicleMonitorVehicle } from '../../../core/services/vehicle-monitor.service';
import { VehicleMonitorMarkerService } from '../../../core/services/vehicle-monitor-markers.service';

@Component({
  selector: 'app-building-camera',
  standalone: true,
  imports: [
    CommonModule,
    FloorVisualizerComponent,
    IncidentVisualizerComponent,
    SafezoneCreatorComponent,
    BlenderCameraComponent,
  ],
  templateUrl: './building-camera.component.html',
  styleUrl: './building-camera.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingCameraComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entity: any = {};
  /// new code
  @Input() buildingMapEntity: any;
  @Input() eventMapEntity: any;
  @Input() alert: any;
  //@Input() incidentCategoryList: any = {};
  @Input() buildingOrgId = '';
  @HostBinding('class.enableMonitor') @Input() enableMonitor = false;
  @HostBinding('class.enablePlayback') @Input() enablePlayback = false;
  @HostBinding('class.enableInteraction') @Input() enableInteraction = false;
  @Input() playbackCameraSessions: any[] = [];
  @Input() showCloseEntityCamera: boolean = false;
  @Input() floorBrushStyle: any = {};
  @Input() minFloor: number = 0;
  @Input() maxFloor: number = 0;
  @Input() selectedFloorId: string = '';
  fullAddress: string = '';
  @Input() numFloor: number = 0;
  @Input() topFloorHeight: number = 0;
  @Input() areaTotal: any = 0;
  @Input() areaMax: any = 0;
  @Input() areaMin: any = 0;
  @Input() areaMean: any = 0;
  @Input() firstResponderCountAll: any = 0;
  @Input() totalSuspectCount: any = 0;
  @Input() showInfoButton: boolean = false;
  @Input() showingStats: boolean = false;
  @Input() showBrush: boolean = false;
  @Input() bottomPadding: number = 0;
  @Input() hideEventDetailsForLiveNotification: boolean = false;
  @Output() close = new EventEmitter<void>();
  userByPerimeter: any;
  floorsDetails: any[] = [];
  @ViewChild(BlenderCameraComponent) blenderCamera?: BlenderCameraComponent;
  apiSubscription: Subscription | undefined;
  private destroy$ = new Subject<void>();
  numberOfUnknownUserOnStreet: number = 0;
  numberOfSafUserOnStreet: number = 0;
  numberOfDangerUserOnStreet: number = 0;
  totalFloorUnSafeCount: number = 0;
  totalFloorSafeCount: number = 0;
  totalFloorUnknownCount: number = 0;
  totalFloorSuspectCount: number = 0;

  buildingData: any = null;
  numberOfSuspectUserOnStreet: number = 0;
  totalAffectedUserCount: number = 0;
  incidentCategoryList: any[] = [];
  incidentCampusCategoryList: any[] = [];
  sortOptions = ['Descending', 'Ascending', 'User Count', 'Unsafe Count'];
  sortbyoption = this.sortOptions[0];
  filterOptions = ['All', 'Users Only', 'Unsafe Users Only'];
  filterOption = this.filterOptions[0];
  private _cachedTotalElapsedTime: string = '';
  private _cachedCurrentIncidentTime: string = '';
  private _cachedElapsedTimePct: number = 0;
  private _lastUpdateTime: number = 0;
  private readonly UPDATE_INTERVAL = 1000;

  incidentPermissions: any = {};
  eventStatus = 'active';
  floorMapEntity: any = {};
  showGrandchild: boolean | undefined = false;
  activeFloorIndex: number | null = null;
  buildingEntity: any;
  labelEntity: any;
  camera: any;
  viewer: any;
  private _moveEndListener: any;
  userStatusPollerSub: Subscription | undefined;
  mapentityid: any;
  private isDestroyed = false;
  private lastFloorData: Record<string, any> = {};
  currentFloorData: Record<string, any> = {};
  lastFloorStatus: Record<string, string> = {};
  private playbackDict: any = {};
  hasRoom = false;
  private calculateIntervalSub?: Subscription;
  highGeometryLocation: any = [];
  incidentId: any | undefined;
  @Output() addSafeZoneStatus = new EventEmitter<boolean>();
  @Output() addSafeZone = new EventEmitter<string>();
  isSafeZoneMode: boolean = false;
  campusBuildings: any[] = [];
  campusDetails: any = {};
  selectedBuildingName: string = 'Building';
  perimeterId: any;
  buildingId: any;
  campusUserData: any = null; // Store campus user data from API

  @ViewChild('noUsersModal') noUsersModal!: TemplateRef<any>;
  campusMapEntity: any;
  vehicleViewOn = false;
  vehiclePlaybackOpen = false;
  vehicleSpeeds = [1, 2, 5, 10] as const;
  vehicleSnapshot: VehicleMonitorSnapshot | null = null;
  selectedVehicle: VehicleMonitorVehicle | null = null;
  vehiclePollError: string | null = null;
  private readonly vehiclePollStop$ = new Subject<void>();

  constructor(
    private cameraService: CameraService,
    private incidentCategoryService: IncidentCategoryService,
    private organizationUtilService: OrganizationUtilService,
    private windowService: WindowService,
    private dataService: DataService,
    private modalService: NgbModal,
    public floorService: FloorService,
    private sessionOptionsService: SessionOptionsService,
    private DataContext: DataContextService,
    private coresService: CoresService,
    private spinnerService: NgxSpinnerService,
    private deviceService: DeviceService,
    private illumliveService: IllumLiveService,
    private timelineService: TimelineService,
    private cdr: ChangeDetectorRef,
    private arcAngelLiveModeService: ArcAngelLiveModeService,
    private threeJsBuildingIntegration: ThreeIntegrationService,
    private vehicleMonitor: VehicleMonitorService,
    private vehicleMarkers: VehicleMonitorMarkerService,
  ) { }
  ngOnInit(): void {
    this.isDestroyed = false;
    // this.loadOrgIncidentCategoryInfo();
    this.getActionSessionForCreatePerimeter();

    this.setup();
    this.getCameraSessionsForIncidentPlayback();
    this.subscribeToTimeline();
    this.vehicleMarkers.pickedTrackerId$.pipe(takeUntil(this.destroy$)).subscribe((trackerId) => {
      if (!this.vehicleViewOn) {
        return;
      }
      this.selectVehicle(trackerId);
    });
    this.vehicleMonitor.vehicleViewOn$.pipe(takeUntil(this.destroy$)).subscribe((on) => {
      this.vehicleViewOn = on;
      if (!on) {
        this.vehiclePlaybackOpen = false;
        this.selectedVehicle = null;
        this.vehicleSnapshot = null;
      }
      this.cdr.markForCheck();
    });
    this.vehicleMonitor.latestSnapshot$.pipe(takeUntil(this.destroy$)).subscribe((snapshot) => {
      this.vehicleSnapshot = snapshot;
      this.syncSelectedVehicle();
      this.cdr.markForCheck();
    });
    this.timelineService.playbackComplete$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.stopCalculateInterval();
    });
    // Subscribe to building mode changes
    this.arcAngelLiveModeService.currentLiveIncidentStatus$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((currentIncidentStatus: boolean) => {
        //this.isBuildingMode = isBuilding;
        if (currentIncidentStatus) {
          this.showReturningMonitorModePopup();
        }
      });
  }

  onBuildingChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    const perimeterId = target.value;
    const selectedBuilding = this.campusBuildings.find((b: any) => b.perimeterId == perimeterId);
    if (selectedBuilding) {
      this.buildingMapEntity = selectedBuilding;
      if (this.buildingMapEntity?.floorPerimeters) {
        this.floorsDetails = this.buildingMapEntity.floorPerimeters.slice().reverse();
      } else {
        this.floorsDetails = [];
      }
      this.fullAddress = this.buildingMapEntity?.pin?.object?.attributes?.address || '';
      this.calculateFloorAreasAndHeights();
      this.blenderCamera?.update3dViewAvailability();

      if (this.enableMonitor && !this.incidentId) {
        this.getUserLocationInBuilding(this.buildingMapEntity.perimeterId);
      }
      this.buildingId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.object?.id;

      this.activeFloorIndex = null;
      this.floorService.toggleGrandchild(false);
      this.cdr.detectChanges();
    }
  }

  updatePolygonMaterial(): void {
    const floorPerimeters = this.buildingMapEntity.getFloorPerimeters();
    floorPerimeters.forEach((floorPerimeter: any) => {
      // Iterate through the perimeters object
      if (floorPerimeter.perimeters) {
        Object.values(floorPerimeter.perimeters).forEach((perimeter: any) => {
          if (perimeter && typeof perimeter.setMaterialFromStatuss === 'function') {
            // perimeter.setMaterialFromStatuss();
            this.threeJsBuildingIntegration.setMaterialFromStatus(perimeter);
          }
        });
      }
    });
  }
  setup() {
    const buildingEntity = this.DataContext.getMapEntity(
      this.entity.buildingMapEntity.id
    );
    if (buildingEntity.arcLiveMapEntity.type === 'CampusMapEntity') {
      this.campusMapEntity = buildingEntity.arcLiveMapEntity;
      this.buildingMapEntity = this.campusMapEntity.associatedBuilding[0];
      this.campusBuildings = this.campusMapEntity.associatedBuilding
    } else {
      this.buildingMapEntity = buildingEntity.arcLiveMapEntity;
    }
    this.viewer = this.coresService.getViewer();
    this.camera = this.viewer?.camera;
    // Hide Cesium toolbar buttons when building is opened
    this.hideCesiumToolbarButtons();
    this.enableInteraction = this.sessionOptionsService.isLiveMode();
    this.enableMonitor = this.sessionOptionsService.isMonitorMode();
    this.enablePlayback = this.sessionOptionsService.isPlaybackMode();
    if (this.enableInteraction && !this.entity?.obj) {
      // procall live mode - no incident
      this.eventMapEntity = null;
    } else if (this.entity?.obj) {
      this.eventMapEntity = this.entity;
    } else {
      this.eventMapEntity = this.buildingMapEntity.incidents?.[0];
    }

    if (this.enablePlayback) {
      this.initializePlaybackUserCounts();
      this.initializePlaybackData();
      if (this.buildingMapEntity?.floorPerimeters) {
        this.floorsDetails = this.buildingMapEntity.floorPerimeters.slice().reverse();
      } else if (this.buildingMapEntity?.getFloorPerimeters) {
        this.floorsDetails = this.buildingMapEntity.getFloorPerimeters().slice().reverse();
      }
    }
    this.numFloor = this.buildingMapEntity.getFloorPerimeters().length;

    // this.arcAngelService.showOnlyMyBuilding?.(this.buildingMapEntity.getBuildingId());

    this.selectedFloorId = '';
    this.showBrush = this.numFloor > 10;
    this.bottomPadding = this.enablePlayback ? 200 : 0;

    // Initialize Three.js integration for enhanced building visualization
    // this.initializeEnhancedBuildingView();

    const floorNumbers = this.buildingMapEntity.getFloorPerimeters().map((f: any) => f.floorNumber);
    this.minFloor = Math.min(...floorNumbers);
    this.maxFloor = Math.max(...floorNumbers);

    if (this.buildingMapEntity) {
      const maxFloorEntity = this.buildingMapEntity.getFloorPerimeters()[
        this.buildingMapEntity.getFloorPerimeters().length - 1
      ];

      if (this.viewer && maxFloorEntity && typeof this.buildingMapEntity.initViewPosLon === 'number' && typeof this.buildingMapEntity.initViewPosLat === 'number') {
        this.labelEntity = this.coresService.getViewer().entities.add({
          position: Cesium.Cartesian3.fromDegrees(
            this.buildingMapEntity.initViewPosLon,
            this.buildingMapEntity.initViewPosLat,
            maxFloorEntity.getHeight() + 30
          ),
          label: {
            text: '',
          },
          show: false,
        });

        // Move camera to init view
        this.viewer.camera.cancelFlight();

        // Remove any previous moveEnd listener to avoid duplicates
        if (this._moveEndListener) {
          this.viewer.camera.moveEnd.removeEventListener(this._moveEndListener);
        }
        // Define and add the moveEnd listener
        this._moveEndListener = () => {
          const camera = this.viewer.camera;
          const height = camera.positionCartographic.height;
          const pitch = camera.pitch;
          const roll = camera.roll;
          if (this.labelEntity && this.labelEntity.label) {
            this.labelEntity.label.text =
              'height: ' +
              Number(height).toFixed(5) +
              ', pitch: ' +
              Number(pitch).toFixed(5) +
              ', roll: ' +
              Number(roll).toFixed(5);
          }
        };
        this.viewer.camera.moveEnd.addEventListener(this._moveEndListener);

        this.setupCameraMoveEndListener();
        // setup camera listener
        this.setupCameraListener();
      }
    }
    this.startCalculateInterval();
  }
  private initializePlaybackData(): void {
    if (!this.organizationUtilService.data.playbackBuildingViewData) {
      this.organizationUtilService.data.playbackBuildingViewData = {};
    }
    if (!this.organizationUtilService.data.playbackBuildingViewDataDict) {
      this.organizationUtilService.data.playbackBuildingViewDataDict = {};
    }
  }
  private initializePlaybackUserCounts(): void {
    // Initialize counts that will be updated by playback data
    this.numberOfUnknownUserOnStreet = 0;
    this.numberOfSafUserOnStreet = 0;
    this.numberOfDangerUserOnStreet = 0;
    this.numberOfSuspectUserOnStreet = 0;
    this.totalFloorUnSafeCount = 0;
    this.totalFloorSafeCount = 0;
    this.totalFloorUnknownCount = 0;
    this.totalFloorSuspectCount = 0;
    this.totalAffectedUserCount = 0;
  }

  private subscribeToTimeline(): void {
    this.timelineService.start$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.enablePlayback) this.startCalculateInterval();
    });
    this.timelineService.pause$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.enablePlayback) this.stopCalculateInterval();
    });
  }

  private startCalculateInterval(): void {
    this.stopCalculateInterval(); // Ensure no duplicate intervals
    if (this.isDestroyed) return;
    this.calculate();
    this.calculateIntervalSub = interval(1000).pipe(
      debounceTime(100),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (!this.isDestroyed) this.calculate();
    });
  }

  private stopCalculateInterval(): void {
    if (this.calculateIntervalSub) {
      this.calculateIntervalSub.unsubscribe();
      this.calculateIntervalSub = undefined;
    }
  }

  private calculate(): void {
    let inDangerUserCountByFloor = 0;
    let unKnownUserCountByFloor = 0;
    let safeUserCountByFloor = 0;
    let frCountByFloor = 0;

    if (this.enablePlayback && this.entity?.obj?.id) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;

      this.fetchPlaybackDataForTimestamp(clockTime);

      if (this.organizationUtilService.data?.playbackProcall?.closestBeacon) {
        const playbackProcall = this.organizationUtilService.data.playbackProcall;
        const perimeter = this.getPerimeterFromBeaconId(playbackProcall.closestBeacon);
        const floorNumber = this.getFloorNumberFromPerimeterId(perimeter?.arcAngelId);

        if (floorNumber && playbackProcall?.lastSafetyStatus) {
          this.updateFloorInfoForBuilding(perimeter, playbackProcall);
        }
      }
    }

    const buildingsToProcess: any[] = [];
    if (
      this.campusMapEntity?.type === 'CampusMapEntity' &&
      this.enablePlayback
    ) {
      buildingsToProcess.push(...(this.campusBuildings || []));
    } else {
      buildingsToProcess.push(this.buildingMapEntity);
    }

    if (buildingsToProcess.length > 0) {
      const currentFloorStatus: { [key: string]: string } = {};

      buildingsToProcess.forEach((buildingEntity: any) => {
        if (!buildingEntity?.getFloorPerimeters) return;

        buildingEntity.getFloorPerimeters().forEach((floorPerimeter: any) => {
          const unsafeCount = this.getNumberOfUnSafeUsers(floorPerimeter);
          const unknownCount = this.getNumberOfUnknownUsers(floorPerimeter);
          const safeCount = this.getNumberOfSafeUsers(floorPerimeter);
          const firstResponderCount =
            this.getNumberOfFirstResponders(floorPerimeter);
          const totalUsers = unsafeCount + unknownCount + safeCount;

          inDangerUserCountByFloor += unsafeCount;
          unKnownUserCountByFloor += unknownCount;
          safeUserCountByFloor += safeCount;
          frCountByFloor += firstResponderCount;

          let newStatus = 'gray';
          if (totalUsers === 0) {
            newStatus = 'gray';
          } else if (unsafeCount > 0) {
            newStatus = 'unsafe';
          } else if (unknownCount > 0) {
            newStatus = 'unknown';
          } else if (safeCount > 0) {
            newStatus = 'safe';
          }

          currentFloorStatus[floorPerimeter.perimeterId] = newStatus;
          const roomPerimeters = Object.values(
            floorPerimeter.perimeters || {},
          ).filter((perimeter: any) => perimeter.perimeterType === 'ROOM');

          roomPerimeters.forEach((roomPerimeter: any) => {
            const perimeter =
              this.organizationUtilService.data.myPerimeters?.[
              roomPerimeter.arcAngelId
              ];
            if (!perimeter) return;

            const unsafeCountRoom = this.getNumberOfUnSafeUsers({
              perimeterId: roomPerimeter.arcAngelId,
            });
            const unknownCountRoom = this.getNumberOfUnknownUsers({
              perimeterId: roomPerimeter.arcAngelId,
            });
            const safeCountRoom = this.getNumberOfSafeUsers({
              perimeterId: roomPerimeter.arcAngelId,
            });
            const totalUsersRoom =
              unsafeCountRoom + unknownCountRoom + safeCountRoom;

            let roomStatus = 'gray';
            if (totalUsersRoom === 0) {
              roomStatus = 'gray';
            } else if (unsafeCountRoom > 0) {
              roomStatus = 'unsafe';
            } else if (unknownCountRoom > 0) {
              roomStatus = 'unknown';
            } else if (safeCountRoom > 0) {
              roomStatus = 'safe';
            }

            const lastRoomStatus =
              this.lastFloorStatus[roomPerimeter.arcAngelId] || 'initial';
            currentFloorStatus[roomPerimeter.arcAngelId] = roomStatus;

            if (lastRoomStatus !== roomStatus) {
              setTimeout(() => {
                if (roomStatus === 'gray' && totalUsersRoom === 0) {
                  perimeter.resetSafetyStatusByStats(perimeter);
                  perimeter.setMaterialFromStatuss(perimeter);
                } else if (roomStatus !== 'gray') {
                  perimeter.setSafetyStatusByStats(roomStatus);
                  perimeter.setMaterialFromStatuss(perimeter);
                }
                if (roomStatus !== 'gray' || totalUsersRoom > 0) {
                  this.threeJsBuildingIntegration.updatePerimeterStatusVisual(
                    perimeter,
                    roomStatus as any,
                  );
                } else {
                  this.threeJsBuildingIntegration.updatePerimeterStatusVisual(
                    perimeter,
                    'gray',
                  );
                }
              }, 50);
            }
          });
        });
      });
      this.lastFloorStatus = { ...currentFloorStatus };
    }

    this.totalFloorUnSafeCount = inDangerUserCountByFloor;
    this.totalFloorUnknownCount = unKnownUserCountByFloor;
    this.totalFloorSafeCount = safeUserCountByFloor;
    this.firstResponderCountAll = frCountByFloor;

    let inDangerUser = 0;
    let unKnownUser = 0;
    let safeUser = 0;
    let total = 0;

    if (this.enablePlayback) {
      // Get playback user counts from service data
      inDangerUser = this.getInDangerUserCountAll();
      unKnownUser = this.getUnknownUserCountAll();
      safeUser = this.getSafeUserCountAll();
      total = this.getTotalCountAll();
    }

    this.totalAffectedUserCount = Math.max(0, total - (inDangerUserCountByFloor + unKnownUserCountByFloor + safeUserCountByFloor));
    this.updateFloorDetailsWithCounts();

    const now = Date.now();
    if (now - this._lastUpdateTime >= this.UPDATE_INTERVAL) {
      this._cachedTotalElapsedTime = this.calculateTotalElapsedTime();
      this._cachedCurrentIncidentTime = this.calculateCurrentIncidentTime();
      this._cachedElapsedTimePct = this.calculateElapsedTimePct();
      this._lastUpdateTime = now;

      this.cdr.detectChanges();
    }
    const unknownUsers = this.getNumberOfUnknownUsersForStreet();
    //const incidentUpdates = this.getNumberOfIncidentUpdatesOnStreet();
    this.numberOfUnknownUserOnStreet = unknownUsers;//unknownUsers  === 0 ? 0 : Math.max(0, unknownUsers - incidentUpdates);
    this.numberOfSafUserOnStreet = this.getNumberOfSafeUsersForStreet();
    this.numberOfDangerUserOnStreet = this.getNumberOfInDangerUsersForStreet();
    this.numberOfSuspectUserOnStreet = this.getNumberOfSuspectForStreet();

    if (this.buildingMapEntity) {
      this.buildingMapEntity.dangerUserCount = this.getInDangerUserCountAll();
      this.buildingMapEntity.safeUserCount = this.getSafeUserCountAll();
      this.buildingMapEntity.unknownUserCount = this.getUnknownMinusSuspectCount();
      this.buildingMapEntity.suspectUserCount = this.getInSuspectUserCountAll();
      this.buildingMapEntity.buildingUsers = this.userByPerimeter;
    }
    if (this.campusMapEntity) {
      this.campusMapEntity.dangerUserCount = this.getCampusDangerCountAll();
      this.campusMapEntity.safeUserCount = this.getCampusSafeCountAll();
      this.campusMapEntity.unknownUserCount = this.getCampusUnknownMinusSuspectCount();
      this.campusMapEntity.suspectUserCount = this.getCampusSuspectCountAll();
      this.campusMapEntity.buildingUsers = this.userByPerimeter;
    }
    this.blenderCamera?.syncAlertHighlights();
  }

  private fetchPlaybackDataForTimestamp(timestamp: number): void {
    if (!this.entity?.obj?.id) return;

    this.illumliveService.getUserStatusByPerimeterForPlaybackMulti(
      this.entity.obj.id,
      timestamp
    ).subscribe({
      next: (result) => {
        const dict = this.organizationUtilService.data.playbackBuildingViewDataDict[String(timestamp)];
        if (dict) {
          this.playbackDict = dict;
          this.blenderCamera?.buildLiveUserDataFromPlayback(dict);
          this.cdr.markForCheck();
        }
      },
      error: (error) => {
        console.error('Error fetching playback data:', error);
      }
    });
  }
  // Replace the existing methods with cached versions
  getTotalElapsedTime(): string {
    const t = Math.round(this.getTotalElapsedTimestamp() / 1000);
    return this.sec2str(t);
  }

  getCurrentIncidentTime(): string {
    if (this.eventMapEntity) {
      const elapsedTime = this.getElapsedTime(
        this.eventMapEntity.timestamp,
        this.coresService.getCurrentTimestamp() - 1000
      );
      if (elapsedTime[0].startsWith('-')) {
        return '0:00:00';
      }
      return elapsedTime;
    }
    return '0:00:00';
  }

  private getElapsedTime(dateStart: any, dateCurrent: any): string {
    const duration = moment.duration(moment(dateCurrent).diff(moment(dateStart)));
    return (
      Math.floor(duration.asHours()) +
      moment.utc(duration.asMilliseconds()).format(':mm:ss')
    );
  }

  getElapsedTimePct(): number {
    if (!this.eventMapEntity) return 0;
    const elapsed = this.coresService.getCurrentTimestamp() - this.eventMapEntity.timestamp;
    const total = this.getTotalElapsedTimestamp();
    let pct = total > 0 ? Math.floor((elapsed / total) * 100) : 0;
    if (pct <= 1) pct = 0;
    if (pct >= 99) pct = 100;
    return pct;
  }

  // Private methods to calculate the actual values
  private calculateTotalElapsedTime(): string {
    const t = Math.round(this.getTotalElapsedTimestamp() / 1000);
    return this.sec2str(t);
  }

  private calculateCurrentIncidentTime(): string {
    if (this.eventMapEntity) {
      const elapsedTime = this.getElapsedTime(
        this.eventMapEntity.timestamp,
        this.coresService.getCurrentTimestamp() - 1000
      );
      if (elapsedTime.startsWith('-')) {
        return '0:00:00';
      }
      return elapsedTime;
    }
    return '0:00:00';
  }

  private calculateElapsedTimePct(): number {
    if (!this.eventMapEntity) return 0;
    const elapsed = this.coresService.getCurrentTimestamp() - this.eventMapEntity.timestamp;
    const total = this.getTotalElapsedTimestamp();
    let pct = total > 0 ? Math.floor((elapsed / total) * 100) : 0;
    if (pct <= 1) pct = 0;
    if (pct >= 99) pct = 100;
    return pct;
  }


  // Add this new method to update floor details
  private updateFloorDetailsWithCounts(): void {
    if (this.floorsDetails && this.floorsDetails.length > 0) {
      this.floorsDetails = this.floorsDetails.map((floor) => {
        const unsafe = this.getNumberOfUnSafeUsers(floor);
        const safe = this.getNumberOfSafeUsers(floor);
        const unknown = this.getNumberOfUnknownUsers(floor);
        const suspect = this.getNumberOfSuspectUsers(floor);

        return {
          ...floor,
          unsafe: unsafe,
          safe: safe,
          unknown: unknown,
          suspect: suspect
        };
      });
    }
  }

  private getPerimeterFromBeaconId(beaconId: string): any {
    return this.organizationUtilService.data.myBeacons?.[beaconId];
  }

  private getFloorNumberFromPerimeterId(perimeterId: string): number | null {
    const perimeter = this.organizationUtilService.data.myPerimeters?.[perimeterId];
    return perimeter?.floorNumber || null;
  }

  private updateFloorInfoForBuilding(perimeter: any, playbackProcall: any): void {
  }

  private getNumberOfFirstResponders(floorPerimeter: any): number {
    return 0;
  }

  setupCameraMoveEndListener(): void {
    // Remove any existing camera change listener with this key
    this.cameraService.removeCameraChangeListener?.('cameraMoveEndListener');

    let setupDone = false;
    let center: any, transform: any;
    let lastCameraPosition: any = {};
    let distanceToBuildingBase = 0;

    if (!this.viewer || !this.camera || !this.buildingMapEntity) return;

    this.cameraService.addCameraChangeListener?.('cameraMoveEndListener',
      (height: number, pitch: number, roll: number) => {
        if (!setupDone && typeof this.buildingMapEntity.initViewPosLon === 'number' && typeof this.buildingMapEntity.initViewPosLat === 'number') {
          // Initialize camera position
          center = Cesium.Cartesian3.fromDegrees(
            this.buildingMapEntity.initViewPosLon,
            this.buildingMapEntity.initViewPosLat,
            10
          );

          const heading = this.buildingMapEntity.initViewHeading || 0;
          const range = this.buildingMapEntity.initViewRange || 300;
          const camPitch = this.buildingMapEntity.initViewPitch || -0.4;

          transform = Cesium.Transforms.eastNorthUpToFixedFrame(center);

          this.camera.lookAtTransform(
            transform,
            new Cesium.HeadingPitchRange(heading, camPitch, range)
          );

          this.buildingMapEntity.hide?.();
          setupDone = true;
        }

        // Track current camera position
        const currentCameraPosition = {
          heading: this.viewer.camera.heading,
          pitch: pitch,
          roll: roll,
          heightInMeter: this.viewer.camera.positionCartographic.height,
          lat: this.viewer.camera.positionCartographic.latitude,
          lon: this.viewer.camera.positionCartographic.longitude,
          buildingLat: this.buildingMapEntity.initViewPosLat,
          buildingLon: this.buildingMapEntity.initViewPosLon
        };

        // Calculate distance to building base
        distanceToBuildingBase = this.getDistanceToBuildingBase(
          this.viewer.camera.positionCartographic.height,
          pitch
        );

        // // Limit max distance
        // if (distanceToBuildingBase > 10000) {
        //   this.camera.lookAtTransform(
        //     transform,
        //     new Cesium.HeadingPitchRange(
        //       lastCameraPosition.heading,
        //       lastCameraPosition.pitch,
        //       9000
        //     )
        //   );
        // }

        lastCameraPosition = currentCameraPosition;

        // Update debug label if stats are showing
        if (this.showingStats && this.labelEntity) {
          const label =
            'height: ' + Number(height).toFixed(5) +
            ', pitch: ' + Number(pitch).toFixed(5) +
            ', roll: ' + Number(roll).toFixed(5);
          this.labelEntity.label.text = label;
        }
      }
    );

    // Trigger initial camera movement
    (this.cameraService as any).moveUp?.(50);
  }
  setupCameraListener(): void {
    if (this.buildingMapEntity?.cesiumEntity?.polygon) {
      const polygon = this.buildingMapEntity.cesiumEntity.polygon;
      const hierarchy = polygon.hierarchy?.getValue?.() || polygon.hierarchy;
      const positions = hierarchy?.positions || hierarchy;
      if (!positions || !Array.isArray(positions) || positions.length === 0) return;
      const buildingCenter = this.centerOfBuilding(positions);

      this.cameraService.removeCameraChangeListener('cameraListener');
      this.cameraService.addCameraChangeListener('cameraListener', () => {
        const cameraPosition = this.getCameraPosition();
        if (!cameraPosition) return;
        if (this.buildingMapEntity.cesiumEntity) {
          const distance = this.distanceVector(buildingCenter, cameraPosition);
          const surroundings = this.buildingMapEntity.getSurroundings?.() || [];
          for (let i = 0; i < surroundings.length; i++) {
            const surroundingPolygon = surroundings[i]?.polygon;
            const surroundingHierarchy = surroundingPolygon?.hierarchy?.getValue?.() || surroundingPolygon?.hierarchy;
            const surroundingPositions = surroundingHierarchy?.positions || surroundingHierarchy;
            if (surroundingPositions && Array.isArray(surroundingPositions) && surroundingPositions.length > 0) {
              const centerOfSurrounding = this.centerOfBuilding(surroundingPositions);
              const newDistance = this.distanceVector(
                centerOfSurrounding,
                cameraPosition
              );
              surroundings[i].show = newDistance >= distance;
            }
          }
        }
      });
    } else {
      // Optionally log error
      // console.error('Building wireframe not found');
    }
  }


  private centerOfBuilding(positions: any[]): any {
    // Simple centroid calculation for a polygon
    let x = 0,
      y = 0,
      z = 0;
    for (let i = 0; i < positions.length; i++) {
      x += positions[i].x;
      y += positions[i].y;
      z += positions[i].z;
    }
    const n = positions.length;
    return new Cesium.Cartesian3(x / n, y / n, z / n);
  }

  private distanceVector(a: any, b: any): number {
    return Cesium.Cartesian3.distance(a, b);
  }

  private getCameraPosition(): any {
    const viewer = this.coresService.getViewer();
    return viewer?.camera?.position;
  }

  // Helper for distance calculation
  private getDistanceToBuildingBase(height: number, pitch: number): number {
    if (pitch >= 0 || pitch <= -Math.PI / 2) {
      return 10000000;
    }
    const dist = height / Math.sin(-pitch);
    return dist;
  }
  getIncidentCategoryDetailsOfCampus(organizationId: number) {
    this.incidentCategoryService
      .getIncidentCategoryForBuilding()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (incidentCategoryDict) => {
          const orgIdStr = String(organizationId);
          this.incidentCampusCategoryList = incidentCategoryDict[orgIdStr] || [];
        },
        error: (error: Error) => {
          console.error('Error fetching alert notifications:', error);
        },
      });
  }
  getIncidentCategoryDetailsOfbuilding(organizationId: number) {
    this.incidentCategoryService
      .getIncidentCategoryForBuilding()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (incidentCategoryDict) => {
          const orgIdStr = String(organizationId);
          this.incidentCategoryList = incidentCategoryDict[orgIdStr] || [];
        },
        error: (error: Error) => {
          console.error('Error fetching alert notifications:', error);
        },
      });
  }
  // getUserLocationInBuilding(buildingPerimeterId: number) {
  //   interval(2000)
  //     .pipe(
  //       takeUntil(this.destroy$),
  //       exhaustMap(() =>
  //         // this.cameraService.getUserStatusInBuilding(buildingPerimeterId)
  //         this.cameraService.getCampusUserStatusInBuilding(buildingPerimeterId)
  //       )
  //     )
  //     .subscribe({
  //       next: (response) => {
  //         if (response && response.data && response.data.length > 0) {
  //           this.highGeometryLocation = response.geofence?.rows[0].geometry.coordinates || [];
  //           this.parseUsers(response.data);
  //         }
  //       },
  //     });
  // }

  getUserLocationInBuilding(buildingPerimeterId: number) {
    // Check if we're in campus mode (campusMapEntity exists)
    const isCampusMode = !!this.campusMapEntity;

    if (isCampusMode) {
      interval(2000)
        .pipe(
          takeUntil(this.destroy$),

          // Skip API calls if incident is active
          filter(() => {
            if (this.buildingMapEntity?.incidents && this.buildingMapEntity?.incidents?.length > 0) {
              return false;
            }
            return true;
          }),

          exhaustMap(() =>
            forkJoin({
              buildingUsers: this.cameraService.getUserStatusInBuilding(
                this.buildingMapEntity.perimeterId
              ),
              campusUsers: this.cameraService.getCampusUserStatusInBuilding(
                this.entity?.object?.id
              )
            })
          )
        )
        .subscribe({
          next: ({ buildingUsers, campusUsers }) => {
            // Handle building API response
            if (buildingUsers?.data?.length > 0) {
              this.parseUsers(buildingUsers.data);
            }

            // Handle campus API response
            if (campusUsers?.data?.length > 0) {
              // Store campus user data for use in getCampusUserCounts
              this.campusUserData = campusUsers.data;

              // Set high geometry location from geofence
              this.highGeometryLocation =
                campusUsers.geofence?.rows[0]?.geometry?.coordinates || [];
            }
          }
        });
    } else {
      // For building mode (non-campus), only call getUserStatusInBuilding
      interval(2000)
        .pipe(
          takeUntil(this.destroy$),
          filter(() => {
            if (this.buildingMapEntity?.incidents && this.buildingMapEntity?.incidents?.length > 0) {
              return false;
            }
            return true;
          }),
          exhaustMap(() =>
            this.cameraService.getUserStatusInBuilding(this.buildingMapEntity.perimeterId)
          )
        )
        .subscribe({
          next: (buildingUsers) => {
            // Handle building API response
            if (buildingUsers?.data?.length > 0) {
              this.parseUsers(buildingUsers.data);
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.stopCalculateInterval();
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    if (this.userStatusPollerSub) {
      this.userStatusPollerSub.unsubscribe();
    }
    this.cameraService.removeCameraChangeListener('cameraListener');
    this.cameraService.removeCameraChangeListener('cameraMoveEndListener');
    // Reset the flag when component is destroyed
    if (this.hideEventDetailsForLiveNotification) {
      this.cameraService.setHideEventDetailsForLiveNotification(false);
    }
    // Mark building camera as closed when component is destroyed
    this.cameraService.setIsBuildingCameraOpen(false);
    if (this.viewer?.camera) {
      // this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      try {
        const worldPos = Cesium.Cartesian3.clone(this.viewer.camera.positionWC);
        const heading = this.viewer.camera.heading;
        const pitch = this.viewer.camera.pitch;
        const roll = this.viewer.camera.roll;
        this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
        if (worldPos && !isNaN(worldPos.x)) {
          this.viewer.camera.setView({
            destination: worldPos,
            orientation: { heading, pitch, roll }
          });
        }
      } catch (e) { }
    }
    this.destroy$.next();
    this.destroy$.complete();
    this.clearStoredFloorData();
    this.vehiclePollStop$.complete();
  }

  toggleVehicleView(): void {
    this.vehicleViewOn = !this.vehicleViewOn;
    if (this.vehicleViewOn) {
      this.autoStartVehiclePlayback();
    } else {
      this.stopVehicleMonitorLayer();
      this.vehiclePlaybackOpen = false;
    }
    this.cdr.markForCheck();
    this.vehicleMonitor.setVehicleViewOn(this.vehicleViewOn);
  }

  private flyToVehicleViewOverview(): void {
    if (!this.viewer?.camera) return;

    let centerLon: number | null = null;
    let centerLat: number | null = null;

    // 1. Check geofence coordinates if available
    if (this.highGeometryLocation && this.highGeometryLocation.length > 0) {
      const ring = Array.isArray(this.highGeometryLocation[0]) && Array.isArray(this.highGeometryLocation[0][0])
        ? this.highGeometryLocation[0]
        : this.highGeometryLocation;

      const pts: { lon: number; lat: number }[] = [];
      for (const pt of ring) {
        if (Array.isArray(pt) && pt.length >= 2 && typeof pt[0] === 'number' && typeof pt[1] === 'number') {
          pts.push({ lon: pt[0], lat: pt[1] });
        }
      }
      if (pts.length > 0) {
        centerLon = pts.reduce((sum, p) => sum + p.lon, 0) / pts.length;
        centerLat = pts.reduce((sum, p) => sum + p.lat, 0) / pts.length;
      }
    }

    // 2. Check campus coordinates from organizationUtilService
    if (centerLon == null || centerLat == null) {
      const campusRows = this.organizationUtilService.data?.myCampus?.campuses || this.organizationUtilService.data?.campuses || [];
      const campusCoords = campusRows[0]?.campusPosition?.coordinates;
      if (campusCoords && campusCoords.length === 2 && typeof campusCoords[0] === 'number' && typeof campusCoords[1] === 'number') {
        centerLon = campusCoords[0];
        centerLat = campusCoords[1];
      }
    }

    // 3. Fallback to campusMapEntity / buildingMapEntity
    if (centerLon == null || centerLat == null) {
      if (typeof this.campusMapEntity?.initViewPosLon === 'number' && typeof this.campusMapEntity?.initViewPosLat === 'number') {
        centerLon = this.campusMapEntity.initViewPosLon;
        centerLat = this.campusMapEntity.initViewPosLat;
      } else if (typeof this.buildingMapEntity?.initViewPosLon === 'number' && typeof this.buildingMapEntity?.initViewPosLat === 'number') {
        centerLon = this.buildingMapEntity.initViewPosLon;
        centerLat = this.buildingMapEntity.initViewPosLat;
      } else if (typeof this.campusMapEntity?.getLongitude === 'function' && typeof this.campusMapEntity?.getLatitude === 'function') {
        const cLon = this.campusMapEntity.getLongitude();
        const cLat = this.campusMapEntity.getLatitude();
        if (cLon && cLat) {
          centerLon = cLon;
          centerLat = cLat;
        }
      } else if (typeof this.buildingMapEntity?.getLongitude === 'function' && typeof this.buildingMapEntity?.getLatitude === 'function') {
        const bLon = this.buildingMapEntity.getLongitude();
        const bLat = this.buildingMapEntity.getLatitude();
        if (bLon && bLat) {
          centerLon = bLon;
          centerLat = bLat;
        }
      }
    }

    if (centerLon != null && centerLat != null) {
      const center = Cesium.Cartesian3.fromDegrees(centerLon, centerLat, 10);
      const transform = Cesium.Transforms.eastNorthUpToFixedFrame(center);

      this.viewer.camera.cancelFlight();
      this.viewer.camera.lookAtTransform(
        transform,
        new Cesium.HeadingPitchRange(
          Cesium.Math.toRadians(0.0),
          Cesium.Math.toRadians(-89.9), // Top-down overview
          4500 // Range for full airport framing matching Image 1
        )
      );
      this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      this.viewer.scene.requestRender();
    }
  }

  sendVehicleCommand(action: string, speed?: number): void {
    this.vehicleMonitor.command(action, speed).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.vehiclePollError = null;
        this.vehicleMonitor.snapshot().pipe(takeUntil(this.destroy$)).subscribe((response) => {
          if (!this.vehicleViewOn || !response?.success || !response.data) {
            return;
          }
          this.vehicleSnapshot = response.data;
          this.syncSelectedVehicle();
          this.vehicleMarkers.apply(response.data, action !== 'reset' && action !== 'stop' && action !== 'reload');
          this.cdr.markForCheck();
          if (action === 'speed' || action === 'start' || action === 'resume') {
            this.startVehiclePoll();
          }
        });
      },
      error: (error) => {
        this.vehiclePollError = error?.error?.message || error?.message || 'Vehicle monitor command failed';
        this.cdr.markForCheck();
      }
    });
  }

  private startVehiclePoll(): void {
    this.vehiclePollStop$.next();
    this.vehiclePollError = null;
    this.vehicleMonitor.snapshot().pipe(
      catchError((error) => of({
        success: false,
        message: error?.error?.message || error?.message || 'Vehicle monitor unavailable',
        data: null
      })),
      expand((response) => {
        const state = response?.data?.simulation?.state;
        const tickMs = this.vehicleMonitor.playbackTickMs(response?.data?.simulation);
        const waitMs = state === 'RUNNING' ? Math.max(100, Math.min(250, tickMs)) : 1000;
        return timer(waitMs).pipe(
          switchMap(() => this.vehicleMonitor.snapshot().pipe(
            catchError((error) => of({
              success: false,
              message: error?.error?.message || error?.message || 'Vehicle monitor unavailable',
              data: null
            }))
          ))
        );
      }),
      takeUntil(this.vehiclePollStop$),
      takeUntil(this.destroy$)
    ).subscribe((response) => {
      if (!this.vehicleViewOn) {
        return;
      }
      if (!response?.success || !response.data) {
        this.vehiclePollError = response?.message || 'Vehicle monitor unavailable';
        this.cdr.markForCheck();
        return;
      }
      this.vehiclePollError = null;
      this.vehicleSnapshot = response.data;
      this.syncSelectedVehicle();
      this.vehicleMarkers.apply(response.data, true);
      this.cdr.markForCheck();
    });
  }

  private stopVehicleMonitorLayer(): void {
    this.vehiclePollStop$.next();
    this.vehicleViewOn = false;
    this.vehicleSnapshot = null;
    this.selectedVehicle = null;
    this.vehiclePollError = null;
    this.vehicleMarkers.clear();
    this.vehicleMonitor.setVehicleViewOn(false);
  }

  closeVehiclePopup(): void {
    this.selectedVehicle = null;
    this.cdr.markForCheck();
  }

  private autoStartVehiclePlayback(): void {
    this.vehicleMonitor.command('speed', 2).pipe(
      catchError(() => of(null)),
      switchMap(() => this.vehicleMonitor.command('start')),
      catchError((error) => {
        const message = String(error?.error?.message || error?.message || '');
        if (/resume/i.test(message)) {
          return this.vehicleMonitor.command('resume');
        }
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: () => this.startVehiclePoll(),
      error: (error) => {
        this.vehiclePollError = error?.error?.message || error?.message || 'Vehicle monitor command failed';
        this.startVehiclePoll();
        this.cdr.markForCheck();
      }
    });
  }

  private selectVehicle(trackerId: string): void {
    this.selectedVehicle = this.vehicleSnapshot?.vehicles.find((vehicle) => vehicle.trackerId === trackerId) || {
      trackerId,
      vehicleNo: '',
      latitude: 0,
      longitude: 0,
      speedKph: 0,
      heading: 0,
      recordedAt: null,
      sequence: 0,
      registration: null,
      authorized: false,
      zone: 'OUTSIDE',
      distanceMeters: null,
      siteId: null
    };
    this.cdr.markForCheck();
  }

  private syncSelectedVehicle(): void {
    if (!this.selectedVehicle || !this.vehicleSnapshot) {
      return;
    }
    const live = this.vehicleSnapshot.vehicles.find((vehicle) => vehicle.trackerId === this.selectedVehicle?.trackerId);
    if (live) {
      this.selectedVehicle = live;
    }
  }

  parseUsers(data: any[]): void {
    let floorData = data;
    const userByPerimeter: { [key: string]: any } = {};

    // Store current data for comparison
    this.currentFloorData = {};
    const currentFloorStatus: { [key: string]: string } = {};

    floorData.forEach((d) => {
      userByPerimeter[d.id || 'street'] = d;

      // Store current floor data
      if (d.type == 'ROOM') {
        const dangerCount = parseInt(d.danger) || 0;
        const unknownCount = parseInt(d.unknown) || 0;
        const safeCount = parseInt(d.safe) || 0;
        const totalUsers = dangerCount + unknownCount + safeCount;

        this.currentFloorData[d.id] = {
          danger: dangerCount,
          unknown: unknownCount,
          safe: safeCount,
          totalUsers: totalUsers
        };

        // Determine the status for this floor
        let newStatus = 'gray';
        if (totalUsers === 0) {
          newStatus = 'gray';
        } else if (dangerCount > 0) {
          newStatus = 'unsafe';
        } else if (unknownCount > 0) {
          newStatus = 'unknown';
        } else if (safeCount > 0) {
          newStatus = 'safe';
        }

        currentFloorStatus[d.id] = newStatus;

        // Only update color if status has changed
        const lastStatus = this.lastFloorStatus[d.id] || 'initial';
        if (lastStatus !== newStatus) {

          const perimeter = this.organizationUtilService.data.myPerimeters?.[d.id];
          if (perimeter) {
            perimeter.setIsPartOfBuilding(true);

            // Add a small delay to prevent rapid flickering
            setTimeout(() => {
              if (newStatus === 'gray' || totalUsers === 0) {
                perimeter.resetSafetyStatusByStats(perimeter);

                this.threeJsBuildingIntegration.updatePerimeterStatusVisual(perimeter, 'gray');
              } else {
                perimeter.setSafetyStatusByStats(newStatus);
                this.threeJsBuildingIntegration.updatePerimeterStatusVisual(perimeter, newStatus as any);
              }
            }, 50); // 50ms delay for smooth transition
          }
        }
      }
    });

    // Check for floors that were in last data but missing in current data
    if (Object.keys(this.lastFloorData).length > 0) {
      Object.keys(this.lastFloorData).forEach(floorId => {
        if (!this.currentFloorData[floorId]) {
          const lastStatus = this.lastFloorStatus[floorId] || 'initial';

          // Only update to gray if it wasn't already gray
          if (lastStatus !== 'gray') {

            currentFloorStatus[floorId] = 'gray';

            const perimeter = this.organizationUtilService.data.myPerimeters?.[floorId];
            if (perimeter) {
              perimeter.setIsPartOfBuilding(true);

              this.threeJsBuildingIntegration.updatePerimeterStatusVisual(perimeter, 'gray');
              // Add delay for smooth transition
              setTimeout(() => {
                perimeter.resetSafetyStatusByStats(perimeter);
                this.threeJsBuildingIntegration.resetSafetyStatusByStats(perimeter);
              }, 50);
            }
          } else {
            // Keep the gray status
            currentFloorStatus[floorId] = 'gray';
          }
        }
      });
    }

    // Update stored data for next comparison
    this.lastFloorData = { ...this.currentFloorData };
    this.lastFloorStatus = { ...currentFloorStatus };

    this.userByPerimeter = userByPerimeter;
    if (this.userByPerimeter) {
      const unknownUsers = this.getNumberOfUnknownUsersForStreet();
      const incidentUpdates = this.getNumberOfIncidentUpdatesOnStreet();
      this.numberOfUnknownUserOnStreet = unknownUsers === 0 ? 0 : Math.max(0, unknownUsers - incidentUpdates);
      this.numberOfSafUserOnStreet = this.getNumberOfSafeUsersForStreet();
      this.numberOfDangerUserOnStreet = this.getNumberOfInDangerUsersForStreet();
      this.numberOfSuspectUserOnStreet = this.getNumberOfSuspectForStreet();

      this.totalAffectedUserCount =
        this.totalFloorUnknownCount +
        this.numberOfUnknownUserOnStreet +
        this.totalFloorUnSafeCount +
        this.numberOfDangerUserOnStreet +
        this.totalFloorSafeCount +
        this.numberOfSafUserOnStreet -
        (this.totalFloorSuspectCount + this.numberOfSuspectUserOnStreet);
    }

    this.blenderCamera?.buildLiveUserDataFromApi(data, this.currentFloorData);
  }

  // *******  here we are checking for floors wise safe, unsafe and unknown users
  updateFloorsWithStatusCount(): void {
    this.floorsDetails = this.floorsDetails.map((floor) => {
      const unsafe =
        this.userByPerimeter && this.userByPerimeter[floor.perimeterId]
          ? this.userByPerimeter[floor.perimeterId].unsafe || 0
          : 0;
      const safe =
        this.userByPerimeter && this.userByPerimeter[floor.perimeterId]
          ? this.userByPerimeter[floor.perimeterId].safe || 0
          : 0;
      const unknown =
        this.userByPerimeter && this.userByPerimeter[floor.perimeterId]
          ? this.userByPerimeter[floor.perimeterId].unknown || 0
          : 0;

      const suspect =
        this.userByPerimeter && this.userByPerimeter[floor.perimeterId]
          ? this.userByPerimeter[floor.perimeterId].suspect || 0
          : 0;
      return { ...floor, unsafe, safe, unknown, suspect };
    });

    this.totalFloorUnSafeCount = this.floorsDetails.reduce(
      (sum, floor) => sum + +(floor.unsafe ?? 0),
      0
    );
    this.totalFloorSafeCount = this.floorsDetails.reduce(
      (sum, floor) => sum + +(floor.safe ?? 0),
      0
    );
    this.totalFloorUnknownCount = this.floorsDetails.reduce(
      (sum, floor) => sum + +(floor.unknown ?? 0),
      0
    );
    this.totalFloorSuspectCount = this.floorsDetails.reduce(
      (sum, floor) => sum + +(floor.suspect ?? 0),
      0
    );

    this.updatePolygonMaterial();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.enableInteraction = this.sessionOptionsService.isLiveMode();
    this.enableMonitor = this.sessionOptionsService.isMonitorMode();
    this.enablePlayback = this.sessionOptionsService.isPlaybackMode();
    const buildingEntity = this.DataContext.getMapEntity(
      this.entity.buildingMapEntity.id
    );
    if (buildingEntity.arcLiveMapEntity.type === 'CampusMapEntity') {
      this.campusMapEntity = buildingEntity.arcLiveMapEntity;
      this.buildingMapEntity = this.campusMapEntity.associatedBuilding[0];
      this.buildingId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.object?.id;
      this.campusBuildings = this.campusMapEntity.associatedBuilding

      if (this.enableMonitor) {
        if (this.entity) {
          if (this.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.buildingMapEntity.floorPerimeters
              .slice()
              .reverse();
          }
          // Load incident categories if opening from notification or if building has floor perimeters
          if (this.hideEventDetailsForLiveNotification || this.buildingMapEntity?.floorPerimeters) {
            this.getIncidentCategoryDetailsOfCampus(
              this.entity.buildingMapEntity?.assignedOrgId ?? this.entity.object?.organizationId ?? this.entity?.obj?.organization ?? this.entity.buildingMapEntity?.pin?.object?.organizationId
            );
          }
          if (this.entity?.eventMapEntity) {
            this.incidentId = this.entity.eventMapEntity.eventId;
          } else if (this.entity.buildingMapEntity.incidents && this.entity.buildingMapEntity.incidents.length > 0) {
            this.incidentId = this.entity.buildingMapEntity.incidents[0].eventId;
          }
          //this.fullAddress = this.entity?.object?.attributes.address || '';
          this.fullAddress = this.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.calculateFloorAreasAndHeights();
          if (this.incidentId) {
            // ******************  Here we will fetch the data by incidentId
            this.cameraService.setCurrentIncidentId(this.incidentId);
            this.startUserStatusPoller();
          }
          else {
            // ************* We are fetching the data for monitor by building perimeter id
            this.getUserLocationInBuilding(this.entity?.object?.id);
          }

        }
      } else if (this.enableInteraction) {
        if (this.entity) {
          if (this.entity.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.buildingMapEntity.getFloorPerimeters().slice()
              .reverse();
          }
          // this.updatePolygonMaterial();

          this.fullAddress = this.entity.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.calculateFloorAreasAndHeights();
          this.startUserStatusPoller();
          this.cameraService.setCurrentIncidentId(this.entity.obj.id);

          // Load incident categories if opening from notification
          if (this.hideEventDetailsForLiveNotification) {
            this.getIncidentCategoryDetailsOfCampus(
              this.entity.buildingMapEntity?.assignedOrgId ?? this.entity.object?.organizationId ?? this.entity?.obj?.organization ?? this.entity.buildingMapEntity?.pin?.object?.organizationId
            );
          }

          //this.getUserLocationInBuilding(this.entity?.object?.id);
        }
      } else if (this.enablePlayback) {
        if (this.entity) {
          if (this.entity.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.entity.buildingMapEntity.floorPerimeters
              .slice()
              .reverse();
          }

          this.fullAddress =
            this.entity.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.cameraService.setCurrentIncidentId(this.entity?.obj.id || this.entity?.object?.id);
        }
      }
    } else {
      this.buildingMapEntity = buildingEntity.arcLiveMapEntity;
      this.buildingId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.object?.id;
      if (this.enableMonitor) {
        if (this.entity) {
          if (this.entity.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.entity.buildingMapEntity.floorPerimeters
              .slice()
              .reverse();
          }
          // Load incident categories if opening from notification or if building has floor perimeters
          if (this.hideEventDetailsForLiveNotification || this.entity.buildingMapEntity?.floorPerimeters) {
            this.getIncidentCategoryDetailsOfbuilding(
              this.entity.buildingMapEntity?.assignedOrgId ?? this.entity.object?.organizationId ?? this.entity?.obj?.organization ?? this.entity.buildingMapEntity?.pin?.object?.organizationId
            );
          }
          if (this.entity?.eventMapEntity) {
            this.incidentId = this.entity.eventMapEntity.eventId;
          } else if (this.entity.buildingMapEntity.incidents && this.entity.buildingMapEntity.incidents.length > 0) {
            this.incidentId = this.entity.buildingMapEntity.incidents[0].eventId;
          }
          //this.fullAddress = this.entity?.object?.attributes.address || '';
          this.fullAddress = this.entity.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.calculateFloorAreasAndHeights();
          if (this.incidentId) {
            // ******************  Here we will fetch the data by incidentId
            this.cameraService.setCurrentIncidentId(this.incidentId);
            this.startUserStatusPoller();
          }
          else {
            // ************* We are fetching the data for monitor by building perimeter id
            this.getUserLocationInBuilding(this.entity?.object?.id);
          }

        }
      } else if (this.enableInteraction) {
        if (this.entity) {
          if (this.entity.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.buildingMapEntity.getFloorPerimeters().slice()
              .reverse();
          }
          // this.updatePolygonMaterial();

          this.fullAddress = this.entity.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.calculateFloorAreasAndHeights();
          this.startUserStatusPoller();
          this.cameraService.setCurrentIncidentId(this.entity.obj.id);

          // Load incident categories if opening from notification
          if (this.hideEventDetailsForLiveNotification) {
            this.getIncidentCategoryDetailsOfbuilding(
              this.entity.buildingMapEntity?.assignedOrgId ?? this.entity.object?.organizationId ?? this.entity?.obj?.organization ?? this.entity.buildingMapEntity?.pin?.object?.organizationId
            );
          }

          //this.getUserLocationInBuilding(this.entity?.object?.id);
        }
      } else if (this.enablePlayback) {
        if (this.entity) {
          if (this.entity.buildingMapEntity?.floorPerimeters) {
            this.floorsDetails = this.entity.buildingMapEntity.floorPerimeters
              .slice()
              .reverse();
          }

          this.fullAddress =
            this.entity.buildingMapEntity?.pin?.object?.attributes?.address || '';
          this.cameraService.setCurrentIncidentId(this.entity?.obj.id || this.entity?.object?.id);
        }
      }
    }
    // Handle selectedFloorId changes - select and display the floor when clicked externally
    if (changes['selectedFloorId'] && !changes['selectedFloorId'].firstChange && this.selectedFloorId) {
      this.selectFloorById(this.selectedFloorId);
    }
    // if (this.enablePlayback) {
    //   return;
    // }

    if (changes['entity'] || changes['buildingMapEntity']) {
      this.blenderCamera?.update3dViewAvailability();
    }
  }
  trackByPerimeterId(index: number, floor: any): any {
    return floor?.id ?? floor?.perimeterId ?? index;
  }
  calculateFloorAreasAndHeights(): void {
    const sqFtPerSqMeter = 10.7639;
    if (!this.buildingMapEntity?.floorPerimeters) return;

    const areas: number[] = [];
    const heights: number[] = [];

    for (let i = 0; i < this.buildingMapEntity.floorPerimeters.length; i++) {
      const floorGeoJson = this.makeGeoJsonFromLocation(this.buildingMapEntity.floorPerimeters[i].locations);
      const areaSqMeter = turf.area(floorGeoJson);
      const areaSqFt = areaSqMeter * sqFtPerSqMeter;
      const areaSqFtRound = Math.round(areaSqFt);
      areas.push(areaSqFtRound);
      heights.push(this.buildingMapEntity.floorPerimeters[i].height);
    }

    this.areaMax = _.max(areas) ?? 0;
    this.areaMin = _.min(areas) ?? 0;
    this.areaMean = Math.round(_.mean(areas) ?? 0);
    this.areaTotal = _.sum(areas) ?? 0;
    this.numFloor = heights.length;
    this.topFloorHeight = 0;

    if (this.numFloor > 1) {
      this.topFloorHeight = heights[heights.length - 1] + (heights[this.numFloor - 1] - heights[this.numFloor - 2]);
      this.topFloorHeight = Math.round(this.topFloorHeight * 3.28);
    }

    // Format numbers with commas
    this.areaMax = Number(this.areaMax).toLocaleString();
    this.areaMin = Number(this.areaMin).toLocaleString();
    this.areaMean = Number(this.areaMean).toLocaleString();
    this.areaTotal = Number(this.areaTotal).toLocaleString();
  }

  makeGeoJsonFromLocation(locations: any[]): any {
    const coordinates: number[][] = [];
    for (let i = 0; i < locations.length; i++) {
      coordinates.push([locations[i][1], locations[i][0]]);
    }
    const feature = {
      type: 'Feature',
      geometry: { type: 'Polygon', coordinates: [coordinates] }
    };
    return { type: 'FeatureCollection', features: [feature] };
  }
  hideStats() { }
  showStats() { }
  // restoreTransparency() {}
  // increaseTransparency() {}
  // panicButtonPressed(cat: any) {}
  showAlert(alert: any) { }
  resolveEvent() {
    if (this.entity.obj.id) {
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
      const component = modalRef.componentInstance as ResponseModalComponent;
      component.message = `Are you sure you want to resolve the event?`;
      component.showCancel = true;
      modalRef.result.then((confirmed: boolean) => {
        if (confirmed) {
          this.spinnerService.show();
          this.incidentCategoryService
            .updateStatusOfEvent(this.entity.obj.id, 'inactive')
            .subscribe(
              (result) => {
                if (result) {
                  this.sessionOptionsService.setMode('Monitor Mode');
                  this.showReturningMonitorModePopup();
                }
                this.spinnerService.hide(); // You should hide the spinner when done
              },
              (error) => {
                this.spinnerService.hide();
                console.error('Error updating event status:', error);
              }
            );
        }
      });
    }
  }
  activateEvent() { }
  closeEvent() { }
  getStartTime(): string {
    const startedAt = this.eventMapEntity?.obj?.startedAt;
    const createdAt = this.eventMapEntity?.obj?.createdAt;
    if (startedAt) {
      return startedAt.replace(/\..*$/, '').replace('T', ' ');
    } else if (createdAt) {
      return createdAt.replace(/\..*$/, '').replace('T', ' ');
    }
    return '';
  }

  getEndTime(): string {
    const endedAt = this.eventMapEntity?.obj?.endedAt;
    const updatedAt = this.eventMapEntity?.obj?.updatedAt;
    if (endedAt) {
      return endedAt.replace(/\..*$/, '').replace('T', ' ');
    } else if (updatedAt) {
      return updatedAt.replace(/\..*$/, '').replace('T', ' ');
    }
    return '';
  }

  getTotalElapsedTimestamp(): number {
    let start: string | undefined;
    if (this.eventMapEntity?.obj?.startedAt) {
      start = this.eventMapEntity.obj.startedAt;
    } else if (this.eventMapEntity?.obj?.createdAt) {
      start = this.eventMapEntity.obj.createdAt;
    }
    let end: string | Date | undefined;
    if (this.eventMapEntity?.obj?.endAt) {
      end = this.eventMapEntity.obj.endAt;
    } else if (this.eventMapEntity?.obj?.updatedAt) {
      end = this.eventMapEntity.obj.updatedAt;
    } else {
      end = new Date();
    }

    let t = 0;
    if (start && end) {
      t = new Date(end).getTime() - new Date(start).getTime();
    }
    return t;
  }

  // Helper: format seconds as d:hh:mm:ss
  private sec2str(t: number): string {
    const d = Math.floor(t / 86400);
    const h = ('0' + (Math.floor(t / 3600) % 24)).slice(-2);
    const m = ('0' + (Math.floor(t / 60) % 60)).slice(-2);
    const s = ('0' + (t % 60)).slice(-2);
    const dayStr = d > 1 ? ' days and ' : d === 1 ? ' day and ' : '';
    return (d > 0 ? d + dayStr : '') + h + ':' + m + ':' + s;
  }

  // Helper: elapsed time string (hh:mm:ss)
  // private getElapsedTime(start: number, end: number): string {
  //   let diff = end - start;
  //   if (diff < 0) return '-';
  //   const t = Math.floor(diff / 1000);
  //   return this.sec2str(t);
  // }

  /**
   * Campus-specific total count
   * Returns total affected users for the entire campus
   */
  getCampusTotalCountAll(): number {
    return this.getCampusUserCounts()?.unknown +
      this.getCampusUserCounts()?.safe +
      this.getCampusUserCounts()?.danger +
      this.getCampusUserCounts()?.suspect;
  }

  /**
   * Campus-specific unknown users count
   */
  getCampusUnknownCountAll(): number {
    return this.getCampusUserCounts()?.unknown;
  }

  /**
   * Campus-specific safe users count
   */
  getCampusSafeCountAll(): number {
    return this.getCampusUserCounts()?.safe;
  }

  /**
   * Campus-specific danger users count
   */
  getCampusDangerCountAll(): number {
    return this.getCampusUserCounts()?.danger;
  }

  /**
   * Campus-specific suspect users count
   */
  getCampusSuspectCountAll(): number {
    return this.getCampusUserCounts()?.suspect;
  }

  /**
   * Campus-specific unknown minus suspect count
   * (if you need this for display)
   */
  getCampusUnknownMinusSuspectCount(): number {
    const counts = this.getCampusUserCounts();
    return counts?.unknown; // or counts.unknown - counts.suspect if needed
  }

  getCampusUserCounts(): { unknown: number, safe: number, danger: number, suspect: number } {
    const counts = {
      unknown: 0,
      safe: 0,
      danger: 0,
      suspect: 0
    };

    // Helper function to safely parse count values
    const parseCount = (value: any): number => {
      if (value === undefined || value === null) return 0;
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        // Parse string to number, handling cases like "00", "0", "2", etc.
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? 0 : parsed;
      }
      return 0;
    };

    // Get the current incident ID
    const currentIncidentId = this.incidentId || this.cameraService.getCurrentIncidentId();

    // First, check if we have campus user data from the API response (live mode)
    if (this.campusUserData && this.campusUserData.length > 0) {
      // Process each item in campusUserData
      this.campusUserData.forEach((item: any) => {
        if (item && item.type === 'CAMPUS') {
          counts.unknown += parseCount(item.unknown);
          counts.safe += parseCount(item.safe);
          counts.danger += parseCount(item.danger);
          counts.suspect += parseCount(item.suspect);
        }
      });

      // If we have campus data, return it
      if (counts.unknown > 0 || counts.safe > 0 || counts.danger > 0 || counts.suspect > 0) {
        return counts;
      }
    }

    // Get the campus ID
    const campusId = this.campusMapEntity?.perimeterId || this.campusMapEntity?.id;

    if (!campusId) {
      return counts;
    }

    // Get data only for the current incident ID to avoid double counting when multiple incidents exist
    if (currentIncidentId && this.deviceService?.data?.userStatusByIncident) {
      const userStatusByIncident = this.deviceService.data.userStatusByIncident;
      const currentIncidentData = userStatusByIncident[currentIncidentId];

      if (currentIncidentData && Array.isArray(currentIncidentData)) {
        // Find the campus entry in the current incident data
        const campusEntry = currentIncidentData.find((item: any) =>
          item.type === 'CAMPUS' || item.id === campusId
        );

        if (campusEntry) {
          counts.unknown += parseCount(campusEntry.unknown);
          counts.safe += parseCount(campusEntry.safe);
          counts.danger += parseCount(campusEntry.danger);
          counts.suspect += parseCount(campusEntry.suspect);

          // If we found campus data for current incident, return it
          if (counts.unknown > 0 || counts.safe > 0 || counts.danger > 0 || counts.suspect > 0) {
            return counts;
          }
        }
      }
    }

    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[String(time)];

      if (stats) {
        const campusStats = stats['campus']; // Filter to only include campus data
        if (campusStats) {
          counts.unknown += parseCount(campusStats.unknown);
          counts.safe += parseCount(campusStats.safe);
          counts.danger += parseCount(campusStats.danger);
          counts.suspect += parseCount(campusStats.suspect);
        }
      }
    } else {
      // For live mode with campus data
      if (this.userByPerimeter && Object.keys(this.userByPerimeter).length > 0) {
        // First, add counts from all buildings under this campus
        Object.keys(this.userByPerimeter).forEach(key => {
          const item = this.userByPerimeter[key];
          // Check if this is a building under this campus
          if (item && item.type === 'BUILDING' && item.parentId === campusId) {
            counts.unknown += parseCount(item.unknown);
            counts.safe += parseCount(item.safe);
            counts.danger += parseCount(item.danger);
            counts.suspect += parseCount(item.suspect);
          }
        });

        // Add street level data
        if (this.userByPerimeter['street']) {
          counts.unknown += parseCount(this.userByPerimeter['street'].unknown);
          counts.safe += parseCount(this.userByPerimeter['street'].safe);
          counts.danger += parseCount(this.userByPerimeter['street'].danger);
          counts.suspect += parseCount(this.userByPerimeter['street'].suspect);
        }

        // Also add the campus-level counts if they exist (as fallback)
        if (this.userByPerimeter[campusId]) {
          // Use the maximum between campus count and building sums
          counts.unknown = Math.max(counts.unknown, parseCount(this.userByPerimeter[campusId].unknown));
          counts.safe = Math.max(counts.safe, parseCount(this.userByPerimeter[campusId].safe));
          counts.danger = Math.max(counts.danger, parseCount(this.userByPerimeter[campusId].danger));
          counts.suspect = Math.max(counts.suspect, parseCount(this.userByPerimeter[campusId].suspect));
        }
      }
    }
    return counts;
  }

  getTotalCountAll(): number {
    return (
      this.getUnknownUserCountAll() +
      this.getSafeUserCountAll() +
      this.getInDangerUserCountAll() +
      this.getInSuspectUserCountAll()
    );
  }

  openSearchUserBox(): void {
    let incidentId: string | undefined;
    if (this.buildingMapEntity?.incidents && this.buildingMapEntity.incidents.length > 0) {
      incidentId = this.buildingMapEntity.incidents[0].eventId;
    }
    if (!incidentId) {
      return;
    }

    const modalRef = this.modalService.open(UserSearchUiComponent, {
      size: 'sm',
      backdrop: 'static',
      windowClass: 'UserSearchUiWindowShape'
    });

    modalRef.componentInstance.incidentId = incidentId;
    modalRef.componentInstance.title = 'Search User';
    modalRef.componentInstance.entity = this.buildingMapEntity?.incidents[0];

    modalRef.result.catch(() => { });
  }

  getNumberOfUnknownUsers(floor: any): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[String(time)];
      if (stats) {
        return stats[floor.perimeterId]?.unknown || 0;
      }
      return 0;
    }
    let number = 0;
    if (this.userByPerimeter && this.userByPerimeter[floor.perimeterId]) {
      number = this.userByPerimeter[floor.perimeterId].unknown || 0;
    }
    return number;
  }

  getNumberOfSafeUsers(floor: any): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[String(time)];
      if (stats) {
        return stats[floor.perimeterId]?.safe || 0;
      }
      return 0;
    }
    let number = 0;
    if (
      !this.userByPerimeter ||
      Object.keys(this.userByPerimeter).length === 0
    ) {
      // number = procallDevices.filter(
      //   (device: any) => device.floorPerimeterId === floor.perimeterId
      // ).length;
    } else if (this.userByPerimeter[floor.perimeterId]) {
      number = this.userByPerimeter[floor.perimeterId].safe || 0;
    }

    return number;
  }

  getNumberOfSuspectUsers(floor: any): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[String(time)];
      if (stats) {
        return stats[floor.perimeterId]?.suspect || 0;
      }
      return 0;
    }
    let number = 0;
    if (this.userByPerimeter && this.userByPerimeter[floor.perimeterId]) {
      number = this.userByPerimeter[floor.perimeterId].suspect || 0;
    }
    return number;
  }
  getNumberOfUnSafeUsers(floor: any): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[String(time)];
      if (stats) {
        return stats[floor.perimeterId]?.danger || 0;
      }
      return 0;
    }
    let number = 0;
    if (
      !this.userByPerimeter ||
      Object.keys(this.userByPerimeter).length === 0
    ) {
      // number = procallDevices.filter(
      //   (device: any) => device.floorPerimeterId === floor.perimeterId
      // ).length;
    } else if (this.userByPerimeter[floor.perimeterId]) {
      number = this.userByPerimeter[floor.perimeterId].danger || 0;
    }

    return number;
  }
  viewFloor(floor: any) { }
  getNumberOfFirstRespondersForStreet(): number {
    return 0;
  }
  getNumberOfUnknownUsersForStreet(): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats) {
        return stats.null ? stats.null.unknown || 0 : 0;
      }
      return 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      return parseInt(this.userByPerimeter.street.unknown || 0);
    }
    return 0;
  }
  getNumberOfSuspectForStreet(): number {
    if (this.userByPerimeter && this.userByPerimeter.street) {
      return parseInt(this.userByPerimeter.street?.suspect || 0);
    }
    return 0;
  }
  getNumberOfSafeUsersForStreet(): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats) {
        return stats.null ? stats.null.safe || 0 : 0;
      }
      return 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      return parseInt(this.userByPerimeter.street.safe || 0);
    }
    return 0;
  }
  getNumberOfInDangerUsersForStreet(): number {
    if (this.enablePlayback) {
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats) {
        return stats.null ? stats.null.danger || 0 : 0;
      }
      return 0;
    }
    if (this.userByPerimeter && this.userByPerimeter?.street) {
      return parseInt(this.userByPerimeter.street.danger || 0);
    }
    return 0;
  }
  playbackVideo(session: any) { }
  getUnknownUserCountAll() {
    if (this.enablePlayback) {
      let street = 0;
      let building = 0;
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats && this.buildingMapEntity?.perimeterId) {
        building = stats[this.buildingMapEntity.perimeterId]
          ? stats[this.buildingMapEntity.perimeterId].unknown || 0
          : 0;
        street = stats.null ? stats.null.unknown || 0 : 0;
      }
      return parseInt(building as any) + parseInt(street as any);
    }
    let street = 0;
    let building = 0;
    if (
      this.userByPerimeter &&
      this.userByPerimeter[this.buildingMapEntity.perimeterId]
    ) {
      building =
        this.userByPerimeter[this.buildingMapEntity.perimeterId].unknown || 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      street = this.userByPerimeter.street.unknown || 0;
    }

    return parseInt(building as any) + parseInt(street as any);
  }
  getUnknownMinusSuspectCount(): number {
    const unknown = this.getUnknownUserCountAll();
    //const suspect = this.getInSuspectUserCountAll();   // no need to minus suspect count from unknown count we are counting separately
    //if (unknown === 0) return 0;
    //return Math.max(0, unknown - suspect);
    return unknown;
  }
  getSafeUserCountAll(): number {
    if (this.enablePlayback) {
      let street = 0;
      let building = 0;
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats && this.buildingMapEntity?.perimeterId) {
        building = stats[this.buildingMapEntity.perimeterId]
          ? stats[this.buildingMapEntity.perimeterId].safe || 0
          : 0;
        street = stats.null ? stats.null.safe || 0 : 0;
      }
      return parseInt(building as any) + parseInt(street as any);
    }
    let street = 0;
    let building = 0;
    if (
      this.userByPerimeter &&
      this.userByPerimeter[this.buildingMapEntity.perimeterId]
    ) {
      building =
        this.userByPerimeter[this.buildingMapEntity.perimeterId].safe || 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      street = this.userByPerimeter.street.safe || 0;
    }

    return parseInt(building as any) + parseInt(street as any);
  }
  getInDangerUserCountAll(): number {
    if (this.enablePlayback) {
      let street = 0;
      let building = 0;
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + '']
      if (stats && this.buildingMapEntity?.perimeterId) {
        building = stats[this.buildingMapEntity.perimeterId]
          ? stats[this.buildingMapEntity.perimeterId].danger || 0
          : 0;
        street = stats.null ? stats.null.danger || 0 : 0;
      }
      return parseInt(building as any) + parseInt(street as any);
    }
    let street = 0;
    let building = 0;
    let number = 0;
    if (
      this.userByPerimeter &&
      this.userByPerimeter[this.buildingMapEntity.perimeterId]
    ) {
      building =
        this.userByPerimeter[this.buildingMapEntity.perimeterId].danger || 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      street = this.userByPerimeter.street.danger || 0;
    }

    number = parseInt(building as any) + parseInt(street as any);
    return number;
  }
  getInSuspectUserCountAll() {
    if (this.enablePlayback) {
      let street = 0;
      let building = 0;
      const clockTime = Math.floor((this.coresService.getCurrentTime() ?? Date.now()) / 1000) * 1000;
      const time = this.illumliveService.getClosestTimestamp(clockTime);
      const stats = this.organizationUtilService.data?.playbackBuildingViewDataDict?.[time + ''];
      if (stats && this.buildingMapEntity?.perimeterId) {
        building = stats[this.buildingMapEntity.perimeterId]
          ? stats[this.buildingMapEntity.perimeterId].suspect || 0
          : 0;
        street = stats.null ? stats.null.suspect || 0 : 0;
      }
      const suspectUserCount = parseInt(building as any) + parseInt(street as any);
      return suspectUserCount === 0 ? this.getNumberOfIncidentUpdatesOnStreet() : suspectUserCount;
    }
    let street = 0;
    let building = 0;
    if (
      this.userByPerimeter &&
      this.userByPerimeter[this.buildingMapEntity.perimeterId]
    ) {
      building =
        this.userByPerimeter[this.buildingMapEntity.perimeterId].suspect || 0;
    }
    if (this.userByPerimeter && this.userByPerimeter.street) {
      street = this.userByPerimeter.street.suspect || 0;
    }
    const suspectUserCount = parseInt(building as any) + parseInt(street as any);
    return suspectUserCount === 0 ? this.getNumberOfIncidentUpdatesOnStreetNewWithSuspectCount() : suspectUserCount;
  }
  getNumberOfIncidentUpdatesOnStreet(): number {
    const updates: any[] = [];
    if (this.buildingMapEntity?.incidents && Array.isArray(this.buildingMapEntity.incidents)) {
      this.buildingMapEntity.incidents.forEach((incident: any) => {
        if (typeof incident.getIncidentUpdatesOnStreet === 'function') {
          updates.push(...incident.getIncidentUpdatesOnStreet());
        }
      });
    }
    const value = _.uniqBy ? _.uniqBy(updates, 'name').length : Array.from(new Set(updates.map(u => u.name))).length;
    return value;
  }
  getNumberOfIncidentUpdatesOnStreetNewWithSuspectCount(): number {
    //const updates: any[] = [];
    return this.getNumberOfSuspectForStreet();
    // if (this.buildingMapEntity?.incidents && Array.isArray(this.buildingMapEntity.incidents)) {
    //   this.buildingMapEntity.incidents.forEach((incident: any) => {
    //     if (typeof incident.getIncidentUpdatesOnStreet === 'function') {
    //       updates.push(...incident.getIncidentUpdatesOnStreet());
    //     }
    //   });
    // }
    // const value = _.uniqBy ? _.uniqBy(updates, 'name').length : Array.from(new Set(updates.map(u => u.name))).length;
    // return value;
  }
  getNumberOfIncidentUpdatesOnFloor(floor: any): number {
    if (floor && typeof floor.getIncidentUpdates === 'function') {
      const updates = floor.getIncidentUpdates();
      return _.uniqBy ? _.uniqBy(updates, 'name').length : Array.from(new Set(updates.map((u: any) => u.name))).length;
    }
    return 0;
  }
  sortOptionClicked(index: number): void {
    this.sortbyoption = this.sortOptions[index];
  }

  filterOptionClicked(index: number): void {
    this.filterOption = this.filterOptions[index];
  }

  restoreTransparency(): void {
    this.buildingMapEntity?.restoreTransparency();
  }

  increaseTransparency(): void {
    this.buildingMapEntity?.increaseTransparency();
  }

  panicButtonPressed(cat: any, isCampusIncident: boolean): void {
    let label = '';
    let id;
    if (cat) {
      label = cat.label;
      id = cat.id;
    }
    this.organizationUtilService.setCampusState(isCampusIncident ? true : false);
    this.createIncident(label, id);
  }

  firePanicPressed(): void {
    this.createIncident('Fire Emergency', 0);
  }
  medicalPanicPressed(): void {
    this.createIncident('Medical Emergency', 1);
  }
  policePanicPressed(): void {
    this.createIncident('Police Emergency', 2);
  }
  generalPanicPressed(): void {
    this.createIncident('General Emergency', 3);
  }
  otherPanicPressed(): void {
    this.createIncident('Other Emergency', 4);
  }

  goToCustom(): void {
    const data: any = {};
    data.orgId = this.buildingMapEntity?.getAssociatedPin()?.object?.organizationId;
    data.arcAngelId = this.buildingMapEntity?.getAssociatedPin()?.object?.attributes?.basePerimeterId;
    data.automaticallyIncludeAllFloors = true;
    this.windowService.openModalWindow(
      data,
      'PerimeterIncidentCreatorDialogController',
      'components/arcangel/views/perimeter-incident-creator-dialog.html'
    );
  }

  private checkIncidentPermission(perimeterId: number): boolean {
    const buildingOrganizationIds =
      this.getBuildingOrganizationIds(perimeterId);

    const privateRows = this.incidentPermissions.privatePerimeter?.rows || [];
    const publicRows = this.incidentPermissions.publicPerimeter?.rows || [];
    const permissions = [...privateRows, ...publicRows];

    // Flatten all organizationIds from permissions
    let permissionOrgIds: any[] = [];
    permissions.forEach((p: any) => {
      if (Array.isArray(p.organizationIds)) {
        permissionOrgIds = permissionOrgIds.concat(p.organizationIds);
      }
    });

    // Remove duplicates
    permissionOrgIds = Array.from(new Set(permissionOrgIds));

    // Check intersection
    const hasIntersection = buildingOrganizationIds.some((id) =>
      permissionOrgIds.includes(id)
    );
    return hasIntersection;
  }

  private getBuildingOrganizationIds(perimeterId: number): any[] {
    return (this.organizationUtilService.myPerimetersForOrg || [])
      .filter((o: any) => o.perimeterId === perimeterId)
      .map((o: any) => o.organizationId);
  }

  private createIncident(
    label: string,
    organizationIncidentCategoryId: number
  ): void {
    const isCampusIncident = this.organizationUtilService.getCampusState();
    if (isCampusIncident) {
      this.perimeterId = this.campusMapEntity?.perimeterId;
    } else {
      this.perimeterId = this.buildingMapEntity?.perimeterId;
    }
    if (!this.checkIncidentPermission(this.perimeterId)) {
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
      const component = modalRef.componentInstance as ResponseModalComponent;
      component.message =
        'You do not have permission to create incident for this building';
      component.showCancel = false;
      return;
    }

    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    const component = modalRef.componentInstance as ResponseModalComponent;
    component.message = `Are you sure you want to create an active ${label} incident?`;
    component.showCancel = true;
    modalRef.result
      .then((confirmed: boolean) => {
        if (confirmed) {
          this.incidentCategoryService.startFixedPerimeterCreation(
            this.entity.object?.organizationId,
            this.perimeterId,
            label,
            undefined,
            true,
            organizationIncidentCategoryId
          );
        }
      })
      .catch(() => { });
  }

  private getActionSessionForCreatePerimeter(): void {
    this.dataService.getActionSessionForCreatePerimeter().subscribe({
      next: (result) => {
        this.incidentPermissions = result;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  viewFloorDetail(floor: any, index: number, sync3dHighlight = true) {
    const originalFloors = this.buildingMapEntity?.getFloorPerimeters() ?? this.floorsDetails ?? [];
    let originalFloor = floor;
    if (floor && (floor.perimeterId || floor.id)) {
      const found = originalFloors.find((f: any) =>
        f && (f.perimeterId === floor.perimeterId || f.id === floor.id)
      );
      if (found) originalFloor = found;
    } else {
      originalFloor = originalFloors[index] ?? originalFloor;
    }

    this.floorService.updateIncidentVisualizer(false);
    this.activeFloorIndex = index;

    this.floorMapEntity = originalFloor;
    this.floorService.updateFloorData(this.floorMapEntity);
    this.cdr.markForCheck();

    const floorIdForDisplay = originalFloor.id || originalFloor.perimeterId || originalFloor.label;
    const babylonHighlightId = originalFloor.perimeterId || originalFloor.arcAngelId || originalFloor.id || originalFloor.label;
    const floorLabel = originalFloor.label || originalFloor.name;

    if (sync3dHighlight && this.threeJsBuildingIntegration && (babylonHighlightId || floorLabel || floorIdForDisplay)) {
      const runSync = (): void => {
        if (this.isDestroyed) {
          return;
        }
        const key = babylonHighlightId || floorIdForDisplay || floorLabel;
        if (key) {
          this.threeJsBuildingIntegration.highlightFloorById(key, true);
        }
        this.floorService.toggleGrandchild(true);
        this.cdr.markForCheck();
      };

      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(() => requestAnimationFrame(runSync));
      } else {
        setTimeout(runSync, 0);
      }
    } else {
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(() => {
          if (!this.isDestroyed) {
            this.floorService.toggleGrandchild(true);
            this.cdr.markForCheck();
          }
        });
      } else {
        setTimeout(() => {
          if (!this.isDestroyed) {
            this.floorService.toggleGrandchild(true);
            this.cdr.markForCheck();
          }
        }, 0);
      }
    }
  }
  viewStreet(index: number) {
    const floorIndex = Number(index);
    this.activeFloorIndex =
      this.activeFloorIndex === floorIndex ? null : floorIndex;
    this.floorService.toggleGrandchild(false);
    const arcLiveEntity = this.entity;
    this.floorService.updateStreetViewData(arcLiveEntity);
    this.floorService.updateIncidentVisualizer(true);
    this.buildingId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.object?.id;
    this.mapentityid = this.buildingMapEntity;
    this.threeJsBuildingIntegration.highlightFloorById(this.mapentityid, false);
  }

  /**
   * Select and display a floor by its ID (called when floor is clicked externally, e.g., in 3D view)
   * @param floorId - The ID of the floor to select (can be perimeterId, id, or label like "Floor 18")
   */
  onFloorSelectedFromBlender(floorId: string): void {
    this.selectFloorById(floorId, false);
  }

  selectFloorById(floorId: string, sync3dHighlight = true): void {
    if (!floorId || !this.floorsDetails || this.floorsDetails.length === 0) {
      return;
    }

    // Normalize the floorId (handle "Floor 18" -> "18" or "FLOOR 18" -> "18")
    const normalizedFloorId = String(floorId).trim();
    const floorNumberMatch = normalizedFloorId.match(/(\d+)/); // Extract number from "Floor 18" -> "18"
    const extractedNumber = floorNumberMatch ? floorNumberMatch[1] : null;

    // Find the floor in floorsDetails that matches the floorId
    const floorIndex = this.floorsDetails.findIndex((floor: any) => {
      if (!floor) return false;

      // Try to match by perimeterId or id (exact match)
      const floorPerimeterId = floor.id || floor.perimeterId;
      if (floorPerimeterId && String(floorPerimeterId) === String(floorId)) {
        return true;
      }

      // Try to match by label (exact match or partial match)
      const floorLabel = floor.label || floor.name;
      if (floorLabel) {
        const normalizedLabel = String(floorLabel).trim();
        // Exact match
        if (normalizedLabel === normalizedFloorId ||
          normalizedLabel.toUpperCase() === normalizedFloorId.toUpperCase()) {
          return true;
        }
        // Extract number from label and compare (e.g., "FLOOR 18" matches "Floor 18")
        if (extractedNumber) {
          const labelNumberMatch = normalizedLabel.match(/(\d+)/);
          if (labelNumberMatch && labelNumberMatch[1] === extractedNumber) {
            return true;
          }
        }
      }

      return false;
    });

    // If floor found, select and display it
    if (floorIndex !== -1) {
      const selectedFloor = this.floorsDetails[floorIndex];
      this.activeFloorIndex = floorIndex;
      this.viewFloorDetail(selectedFloor, floorIndex, sync3dHighlight);
    }
  }


  get is3dBuildingLoading(): boolean {
    return this.blenderCamera?.is3dBuildingLoading ?? false;
  }

  get isShowAllBuildingsMode(): boolean {
    return this.blenderCamera?.isShowAllBuildingsMode ?? false;
  }

  get isCampus3dBuildingLoading(): boolean {
    return (this.blenderCamera?.is3dBuildingLoading ?? false) && this.isShowAllBuildingsMode;
  }

  get isSingleBuilding3dLoading(): boolean {
    if (!this.blenderCamera?.is3dBuildingLoading) {
      return false;
    }
    if (!this.isShowAllBuildingsMode) {
      return true;
    }
    const bId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.id || this.buildingMapEntity?.arcAngelId || this.buildingMapEntity?.object?.id;
    if (!bId) {
      return this.blenderCamera.is3dBuildingLoading;
    }
    const status = this.blenderCamera.getBuildingLoadingStatus(bId);
    if (!status) {
      return this.blenderCamera.is3dBuildingLoading;
    }
    return status.status !== 'done' && status.status !== 'error' && status.progressPercent < 100;
  }

  get singleBuildingProgressPercent(): number {
    if (!this.isShowAllBuildingsMode) {
      return this.buildingProgressPercent;
    }
    const bId = this.buildingMapEntity?.perimeterId || this.buildingMapEntity?.id || this.buildingMapEntity?.arcAngelId || this.buildingMapEntity?.object?.id;
    if (bId) {
      const status = this.blenderCamera?.getBuildingLoadingStatus(bId);
      if (status) {
        return status.progressPercent;
      }
    }
    return this.buildingProgressPercent;
  }

  onBuildingProgressChange(): void {
    this.cdr.markForCheck();
  }

  get buildingProgressPercent(): number {
    return this.blenderCamera?.buildingProgressPercent ?? 0;
  }

  get is3dViewAvailable(): boolean {
    return this.blenderCamera?.is3dViewAvailable ?? false;
  }

  get viewerLiveUserData(): ViewerLiveUserData | null {
    return this.blenderCamera?.viewerLiveUserData ?? null;
  }

  get viewerAlertRecords(): ViewerAlertRecord[] {
    return this.blenderCamera?.viewerAlertRecords ?? [];
  }

  get buildingAssetResolutionKey(): string | null {
    return this.blenderCamera?.buildingAssetResolutionKey ?? null;
  }

  isGlbViewerActive(): boolean {
    return this.blenderCamera?.isGlbViewerActive() ?? false;
  }

  isSingleBuildingGlbActive(): boolean {
    return this.blenderCamera?.isSingleBuildingGlbActive(this.buildingMapEntity) ?? false;
  }

  toggleSingleBuilding3dViewer(event?: Event): void {
    this.blenderCamera?.toggleSingleBuilding3dViewer(this.buildingMapEntity, event);
  }

  toggle3dViewer(event?: Event): void {
    this.toggleSingleBuilding3dViewer(event);
  }

  showAllBuildings3D(): void {
    this.blenderCamera?.showAllBuildings3D();
  }

  closePanel() {
    if (this.vehicleViewOn) {
      this.stopVehicleMonitorLayer();
    }
    this.blenderCamera?.exitIfActive();
    // Clear floor highlight from both services if active
    if (this.threeJsBuildingIntegration && this.threeJsBuildingIntegration.isActive()) {
      this.threeJsBuildingIntegration.clearFloorHighlight();
    }
    this.showCesiumToolbarButtons();
    this.close.emit();
  }
  onImgError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/glyphicons/glyphicons-7-user-add.png'; // path to your default icon
  }
  setActiveFloor(floorId: number): void {
    const floorIndex = Number(floorId);
    this.activeFloorIndex =
      this.activeFloorIndex === floorIndex ? null : floorIndex;
  }

  moveUp(amount: number): void {
    const viewer = this.coresService.getViewer();
    if (viewer) {
      viewer.camera.moveUp(amount);
    }
  }

  moveDown(amount: number): void {
    const viewer = this.coresService.getViewer();
    if (viewer) {
      viewer.camera.moveDown(amount);
    }
  }

  getPitch(): number | undefined {
    const viewer = this.coresService.getViewer();
    if (viewer) {
      return viewer.camera.pitch;
    }
    return undefined;
  }

  getMaxZoomInKM(): number {
    return 26194.6;
  }

  getMinZoomInKM(): number {
    return 0.1;
  }
  getIncidentUserStatusForBuildingView() {
    if (this.enablePlayback) {
      return;
    }
    try {
      // Process procall devices
      const procallDevices = this.processProcallDevices();
      let incidentKey: any = undefined;
      if (this.entity && this.entity.obj && this.entity.obj.id) {
        incidentKey = this.entity.obj.id;
      } else if (this.incidentId) {
        incidentKey = this.incidentId;
      }
      if (incidentKey) {
        const userStatusData = this.deviceService.data.userStatusByIncident?.[incidentKey];
        if (userStatusData && Array.isArray(userStatusData)) {
          this.parseUsers(userStatusData);
        } else {
          // If no user status data, use procall devices for counts
          this.handleProcallDevicesOnly(procallDevices);
        }
      } else {
      }
    } catch (error) {
      console.error('Error in getIncidentUserStatusForBuildingView:', error);
    }
  }

  // Add method to handle procall devices when no user status data is available
  private handleProcallDevicesOnly(procallDevices: any[]): void {
    const userByPerimeter: { [key: string]: any } = {};

    // Count procall devices by floor/building
    procallDevices.forEach(device => {
      const perimeterId = device.floorPerimeterId || device.buildingPerimeterId || 'street';

      if (!userByPerimeter[perimeterId]) {
        userByPerimeter[perimeterId] = {
          id: perimeterId,
          type: device.floorPerimeterId ? 'FLOOR' : (device.buildingPerimeterId ? 'BUILDING' : 'STREET'),
          safe: 0,
          unsafe: 0,
          unknown: 0,
          danger: 0,
          suspect: 0
        };
      }

      // Increment appropriate count based on device status
      if (device.status === 'safe') {
        userByPerimeter[perimeterId].safe++;
      } else if (device.status === 'unsafe' || device.status === 'danger') {
        userByPerimeter[perimeterId].unsafe++;
        userByPerimeter[perimeterId].danger++;
      } else if (device.status === 'unknown') {
        userByPerimeter[perimeterId].unknown++;
      } else if (device.status === 'suspect') {
        userByPerimeter[perimeterId].suspect++;
      } else {
        // Default to unknown if status is not defined
        userByPerimeter[perimeterId].unknown++;
      }
    });

    const userStatusArray = Object.values(userByPerimeter);
    this.parseUsers(userStatusArray);
  }
  // Add import for lodash at the top


  // Add the processProcallDevices method
  private processProcallDevices(): any[] {
    let procallDevices: any[] = [];

    // Get procall devices from UserService equivalent
    // Note: You'll need to replace this with your actual user service
    const userServiceProcallDevices = this.getUserServiceProcallDevices();

    _.forEach(userServiceProcallDevices, (devices) => {
      _.forEach(devices, (device) => {
        if (device.procallId) {
          device = this.getFloorAndBuildingPerimeterIds(device);
          procallDevices.push(device);
        }
      });
    });

    if (this.enableInteraction) {
      const sessionData = this.sessionOptionsService.getSessionData();
      const procallId = sessionData?.eventId;

      if (procallId) {
        procallDevices = _.filter(procallDevices, (device) => {
          return device.procallId === procallId;
        });
      }
    }

    return procallDevices;
  }

  private getFloorAndBuildingPerimeterIds(device: any): any {
    let floorPerimeterId = null;
    let buildingPerimeterId = null;

    if (device.closestBeacon) {
      // Get perimeter from beacon data
      const perimeter = this.organizationUtilService.data.myBeacons?.[device.closestBeacon];

      if (perimeter && perimeter.perimeterType === 'ROOM') {
        // Find the floor perimeter ID from ancestors
        floorPerimeterId = _.find(perimeter.ancestors, (id) => {
          const ancestorPerimeter = this.organizationUtilService.data.myPerimeters?.[id];
          return ancestorPerimeter && ancestorPerimeter.perimeterType === 'FLOOR';
        });

        if (floorPerimeterId) {
          // Find the building perimeter ID from floor's ancestors
          const floorPerimeter = this.organizationUtilService.data.myPerimeters?.[floorPerimeterId];
          if (floorPerimeter && floorPerimeter.ancestors) {
            buildingPerimeterId = _.find(floorPerimeter.ancestors, (id) => {
              const ancestorPerimeter = this.organizationUtilService.data.myPerimeters?.[id];
              return ancestorPerimeter && ancestorPerimeter.perimeterType === 'BUILDING';
            });
          }
        }
      }
    }

    device.floorPerimeterId = floorPerimeterId;
    device.buildingPerimeterId = buildingPerimeterId;

    return device;
  }

  private getUserServiceProcallDevices(): any {
    return this.deviceService?.data?.procallDevices || {};
  }
  startUserStatusPoller(): void {
    if (this.isDestroyed) return;
    // Immediately run once
    this.getIncidentUserStatusForBuildingView();
    // Then poll every 2 seconds
    this.userStatusPollerSub = interval(2000).subscribe(() => {
      if (this.isDestroyed) return;
      this.getIncidentUserStatusForBuildingView();
    });
  }
  showReturningMonitorModePopup(): void {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    const component = modalRef.componentInstance as ResponseModalComponent;
    component.message = 'Event is resolved. Returning to Monitor Mode.';
    component.showCancel = false;
    modalRef.result.then(() => {
      this.sessionOptionsService.goToMonitorMode();
      this.closePanel();
      // Reset the status so the popup doesn't show again
      this.arcAngelLiveModeService.resetCurrentLiveIncidentStatus();
    });
  }

  clearStoredFloorData(): void {
    this.lastFloorData = {};
    this.currentFloorData = {};
  }

  //Playbackmode
  getCameraSessionsForIncidentPlayback(): void {
    if (!this.enablePlayback) {
      return;
    }

    // Get event start and end times
    const eventStartTime = this.entity?.obj?.createdAt;
    const eventEndTime = this.entity?.obj?.endAt;

    if (!eventStartTime || !this.buildingMapEntity?.perimeterId) {
      return;
    }

    const buildingPerimeterId = this.buildingMapEntity.perimeterId;

    // Get sensor list from DataService
    this.dataService.getSensorList().subscribe({
      next: (sensorListData) => {
        if (!sensorListData?.cameraList) {
          return;
        }

        // Filter cameras for this building and get their sensor IDs
        const buildingCameras = sensorListData.cameraList.filter((camera: any) =>
          camera.building?.id === buildingPerimeterId
        );

        const sensorIds = buildingCameras.map((camera: any) => camera.id);

        if (sensorIds.length === 0) {
          return;
        }

        // Get camera sessions for the incident playback period
        this.dataService.getCameraSessionsForIncidentPlayback(
          sensorIds,
          eventStartTime,
          eventEndTime || new Date().toISOString()
        ).subscribe({
          next: (results) => {
            const playbackSessions = results.rows || results.data?.rows || [];

            playbackSessions.forEach((session: any) => {
              const matchingCamera = buildingCameras.find((camera: any) =>
                camera.camera && camera.camera[0]?.id === session.cameraId
              );

              if (matchingCamera) {
                session.camera = matchingCamera;
              }

              if (session.startTime && session.endTime) {
                const startMoment = moment(session.startTime);
                const endMoment = moment(session.endTime);
                const diff = endMoment.diff(startMoment);
                session.duration = moment.utc(diff).format('HH:mm:ss');
              }
            });

            this.playbackCameraSessions = playbackSessions;
          },
          error: (error) => {
            console.error('Error fetching camera sessions for playback:', error);
          }
        });
      },
      error: (error) => {
        console.error('Error getting sensor list:', error);
      }
    });
  }

  sendMessageToAll() {
    const options = {
      useApi: true,
      statuses: ['DANGER', 'SAFE', 'UNKNOWN'],
      perimeterId: undefined,
      incidentId: this.entity.eventId,
      fromOrgId: this.entity?.orgid,
      recipients: 'all users in incident'
    };
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // Danger Users
  public sendMessageToInDangerUsers() {
    const options = {
      useApi: true,
      statuses: ['DANGER'],
      perimeterId: undefined,
      incidentId: this.entity.eventId,
      fromOrgId: this.entity?.orgid,
      recipients: 'all in-danger users in incident'
    };
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // Safe Users
  public sendMessageToSafeUsers() {
    const options = {
      useApi: true,
      statuses: ['SAFE'],
      perimeterId: undefined,
      incidentId: this.entity?.eventId,
      fromOrgId: this.entity?.orgid,
      recipients: 'all safe users in incident'
    };
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // Unknown Users
  public sendMessageToUnknownUsers() {
    const options = {
      useApi: true,
      statuses: ['UNKNOWN'],
      perimeterId: undefined,
      incidentId: this.entity.eventId,
      fromOrgId: this.entity?.orgid,
      recipients: 'all users with unknown status in incident'
    };
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // First Responders
  public sendMessageToFirstResponders() {
    const options = {};
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // Suspect Users
  public sendMessageToSuspectUsers() {
    const options = {
      useApi: true,
      statuses: ['SUSPECT'],
      perimeterId: undefined,
      incidentId: this.entity.eventId,
      fromOrgId: this.entity?.orgid,
      recipients: 'all suspect users in incident'
    };
    this.openMultipleMessageModalWithOptions('Send Message', options);
  }

  // Core function that opens the modal
  private openMultipleMessageModalWithOptions(title: string, options: any, showCancel: boolean = false) {

    if (!options || !options.statuses || options.statuses.length === 0) {
      const modalRef = this.modalService.open(this.noUsersModal, {
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.message = 'No users to notify';
      return;
    }

    const modalRef = this.modalService.open(MultipleMessageComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.options = options;
    modalRef.componentInstance.showCancel = showCancel;

    return modalRef.result;
  }

  onSafeZoneStatusChanged(isActive: boolean) {
    this.isSafeZoneMode = !!isActive;
    this.addSafeZoneStatus.emit(this.isSafeZoneMode);
    try { this.cdr.markForCheck(); } catch (e) { }
  }

  onSafezoneCreated(_: { success: boolean; points: any[] }) {
    this.isSafeZoneMode = false;
    this.mapentityid = this.buildingMapEntity;
    try { this.floorService.updateIncidentVisualizer(true); } catch (e) { }
    try { this.cdr.markForCheck(); } catch (e) { }
  }

  private hideCesiumToolbarButtons(): void {
    if (!this.viewer) return;

    // Hide Home Button
    if (this.viewer.homeButton && this.viewer.homeButton._element) {
      const el = this.viewer.homeButton._element;
      if (el && el.style) {
        el.style.display = 'none';
      }
    }

    // Hide Geocoder
    if (this.viewer.geocoder && this.viewer.geocoder._element) {
      const el = this.viewer.geocoder._element;
      if (el && el.style) {
        el.style.display = 'none';
      }
    }

    // Hide Geocoder Container (Search Bar Container)
    const geocoderContainer = document.querySelector('.cesium-viewer-geocoderContainer');
    if (geocoderContainer && (geocoderContainer as HTMLElement).style) {
      (geocoderContainer as HTMLElement).style.display = 'none';
    }

    // Hide BaseLayerPicker
    if (this.viewer.baseLayerPicker && this.viewer.baseLayerPicker._element) {
      const el = this.viewer.baseLayerPicker._element;
      if (el && el.style) {
        el.style.display = 'none';
      }
    }
  }

  private showCesiumToolbarButtons(): void {
    if (!this.viewer) return;

    // Show Home Button
    if (this.viewer.homeButton && this.viewer.homeButton._element) {
      const el = this.viewer.homeButton._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }

    // Show Geocoder
    if (this.viewer.geocoder && this.viewer.geocoder._element) {
      const el = this.viewer.geocoder._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }

    // Show Geocoder Container (Search Bar Container)
    const geocoderContainer = document.querySelector('.cesium-viewer-geocoderContainer');
    if (geocoderContainer && (geocoderContainer as HTMLElement).style) {
      (geocoderContainer as HTMLElement).style.display = '';
    }

    // Show BaseLayerPicker
    if (this.viewer.baseLayerPicker && this.viewer.baseLayerPicker._element) {
      const el = this.viewer.baseLayerPicker._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }
  }
}
